<template>
  <div>
    <div class="topTitle">
      <el-page-header @back="goBack">
        <template #content>
          <span class="text-large font-600 mr-3"> 分班排课 </span>
        </template>
      </el-page-header>
    </div>

    <div class="searchmsg">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span>基础信息</span>
        </div>

        <div class="clear">
          <div class="fl" style="margin-right: 20px">
            <span class="txt">班级名称:</span>
            <span style="font-size: 14px;">{{ searchForm.name }}</span>
          </div>
          <div class="fl" v-if="$route.query.curriculum_class_type != 3">
            <span class="txt">上课老师:</span>
            <span style="font-size: 14px;">{{ searchForm.lecturer_realname }} ({{
                searchForm.lecturer_name
              }})</span>
          </div>
        </div>

        <div class="clear" style="margin-top: 20px">
          <div class="fl" style="margin-right: 20px">
            <span class="txt">所属学科:</span>
            <span style="font-size: 14px;">{{ searchForm.subject_name }}</span>
          </div>
          <div class="fl" style="margin-right: 20px">
            <span class="txt">课程体系:</span>
            <span style="font-size: 14px;">{{
              searchForm.curriculum_name
            }}</span>
          </div>

          <!-- <div class="fl" style="margin-right: 20px">
            <span class="txt">排课模式:</span>
            {{ value1 ? "系统排课" : "自由上课" }}
          </div> -->

          <div class="fl" style="margin-right: 20px">
            <span class="txt">所属校区:</span>
            <span style="font-size: 14px;">{{ searchForm.campun_name }}</span>
          </div>
          <div class="fl" style="margin-right: 20px">
            <span class="txt">班级模式:</span>
            <span style="font-size:14px" v-if="is_cost_lesson_hour === false">普通模式</span>
            <span style="font-size:14px" v-else>课消模式</span>
          </div>
          <div class="fl" style="margin-right: 20px" v-if="is_cost_lesson_hour != false">
            <span class="txt">课程商品:</span>
            <span style="font-size:14px;" v-for="(item, index) in JSON.parse($route.query.classXmGoodsArr)" :key="index">
              <span> {{ item.xmGoodsInfo.name }} </span>
            </span>
          </div>
          <div class="fl">
            <span class="txt">上课日:</span>
            <span style="font-size:14px;">{{ weekStyle }}
              <span @click="editTime" style="color:#24ABF2;marging-left:10px; cursor:pointer">修改</span></span>
            <!-- <span v-for="(item, index) in JSON.parse($route.query.classXmGoodsArr)" :key="index">
              <span> {{ item.xmGoodsInfo.name }} </span>
            </span> -->
          </div>
          <!-- courseArranging -->
        </div>
      </el-card>
    </div>

    <div class="courseArranging">
      <div class="section">
        <div class="table-style">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="分班管理" name="first" v-if="$route.query.curriculum_class_type != 3">
              <el-row>
                <el-col :span="18">
                  <div>
                    <el-tooltip class="item" effect="dark" content="选择入班学员" placement="bottom-start">
                      <el-button style="margin-top: 10px" class="arrang_btn" type="primary" size="small" @click="AddMoreStudent">
                        添加学员
                        <i class="el-icon-question el-icon--right"></i>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip class="item" effect="dark" content="学员移出班级后,未上讲次会被删除,谨慎操作" placement="top-start">
                      <el-button style="margin-top: 10px" size="small" plain @click="delStudentClassRelation">
                        批量移出班级
                        <i class="el-icon-question el-icon--right"></i>
                      </el-button>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="6" class="searchClass">
                  <el-input v-model="name" placeholder="请输入学员名字" style="width: 70%; margin-top: 20px; margin-right: 10px" clearable @keyup.enter.native="searchName">
                  </el-input>
                  <el-button type="primary" size="mini" @click="searchName">查询</el-button>
                </el-col>
              </el-row>
              <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionOutClassStudent" :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }" stripe>
                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column align="left" width="50" label="序号" fixed>
                  <template slot-scope="scope">{{
                    scope.$index + 1 + (page_no - 1) * page_size
                  }}</template>
                </el-table-column>

                <el-table-column label="学员姓名">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.studentInfo.studentUserInfo.realname
                    }}</span>
                    <span style="color: #e6a23c" v-if="!scope.row.is_vaild">(已出班)</span>
                  </template>
                </el-table-column>
                <el-table-column prop="studentInfo.studentUserInfo.sex" label="性别" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="studentInfo.name" label="学员账号"></el-table-column>
                <el-table-column prop="" label="消耗方式" width="150px" v-if="is_cost_lesson_hour === false ? false : true">
                  <template slot-scope="scope">
                    <!-- @change="changeWay(scope.row)" -->
                    <el-select v-model="scope.row.xm_goods_id" placeholder="请选择" size="mini">
                      <el-option v-for="item in scope.row.xmGoodsList" :key="item.id" :label="item.name" :value="item.id" style="position: relative;">
                        <div style="position: absolute;left: 0;width: 100%;padding: 0 20px;" @click="changeWay(scope.row, item.id)">{{item.name}}</div>
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="剩余课时" width="100px" v-if="is_cost_lesson_hour === false ? false : true">
                  <template slot-scope="scope">
                    <span v-if="scope.row.xm_goods_id === null">--</span>
                    <span v-else>
                      <div class="classHour">
                        <el-select v-model="scope.row.xm_goods_id" size="mini" disabled>
                          <el-option v-for="(item, index) in scope.row.xmGoodsList" :key="index" :label="item.remainingLessonHours.toString()" :value="item.id">
                          </el-option>
                        </el-select>
                      </div>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column prop="missStuTchPlanNum" label="缺勤记录" align="center">
                  <template slot-scope="scope">
                    <el-link @click="absenceFromDuty(scope.row)">{{
                      scope.row.missStuTchPlanNum
                    }}</el-link>
                  </template>
                </el-table-column>

                <el-table-column align="left" label="联系人">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.studentInfo.studentUserInfo.parent_a
                    }}</span>
                    <span>{{
                      scope.row.studentInfo.studentUserInfo.parent_a_phone_num
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" :disabled="!scope.row.is_vaild" @click="getClassListForStuChangeClass(scope.row)">调班</el-button>
                    <el-button type="text" size="mini" @click="yichu(scope.row)">移出班级</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="pagination-style">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="排课管理" name="second">
              <el-row>
                <el-col :span="24">
                  <div style="float: left">
                    <el-tooltip class="item" effect="dark" content="可以添加同科目下,其他课程体系的讲次" placement="top-start">
                      <el-button v-if="$route.query.curriculum_class_type != 3" style="margin-top: 10px" class="arrang_btn" type="primary" size="small" @click="addLectureTimes">
                        添加讲次
                        <i class="el-icon-question el-icon--right"></i>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip class="item" effect="dark" content="选择需要排课的讲次,批量进行排课操作" placement="top-start">
                      <el-button style="margin-top: 10px" class="arrang_btn" type="primary" size="small" @click="goNext">
                        系统排课
                        <i class="el-icon-question el-icon--right"></i>
                      </el-button>
                    </el-tooltip>

                    <el-button style="margin-top: 10px" class="arrang_btn" size="small" @click="deleteNormalClassTchPlan">
                      批量删除
                    </el-button>
                  </div>
                  <!-- <div style="float: right">
                    <el-switch @change="isClass" style="display: block; margin-top: 20px" v-model="value1"
                      active-color="#C0CCDA" inactive-color="#C0CCDA" active-text="系统排课" inactive-text="自由上课"></el-switch>
                  </div> -->
                </el-col>
              </el-row>

              <el-table id="applyTable" @header-dragend="colChange" :data="tableData1" :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }" stripe @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
                <el-table-column align="left" type="index" width="50" label="序号" fixed>
                </el-table-column>

                <el-table-column width="80" align="left" label="封面">
                  <template slot-scope="scope">
                    <el-image style="width: 24px; height: 18px" :src="scope.row.lessionInfo.img_url" fit="cover">
                    </el-image>
                  </template>
                </el-table-column>

                <el-table-column align="left" label="讲次名称" key="1">
                  <template slot-scope="scope">
                    <span>{{ scope.row.lessionInfo.title }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="lecturer_name" label="上课老师" key="2"></el-table-column>

                <el-table-column align="left" key="3" label="上课时间" show-overflow-tooltip :width="widthTable">
                  <template slot-scope="scope">
                    <!-- <span v-if="scope.row.start_class_date === null" style="color: rgba(255, 141, 26, 1)">请设置排课时间</span> -->
                    <span v-if="scope.row.start_class_date === null">--</span>

                    <span v-else>{{ scope.row.start_class_date.slice(0, 16) }} ~
                      {{ scope.row.end_class_date.slice(10, 16) }}
                    </span>
                  </template>
                </el-table-column>

                <!-- <el-table-column align=" center" label="实到/应到" key="4">
                    <template slot-scope="scope">
                      <span @click="num(scope.row)" style="color: blue; cursor: pointer">{{
                        scope.row.sign_num + "/" + scope.row.total_num
                        }}</span></template>
              </el-table-column> -->

                <el-table-column align="left" label="上课状态" key="4">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sign_state === 1">
                      <span v-if="scope.row.sign_state_new == '2'">已结课</span>
                      <span style="color: green" v-if="scope.row.sign_state_new == '1'">上课中</span>
                      <span v-else-if="scope.row.sign_state_new == '3'">补课中</span>
                      <span v-else-if="scope.row.sign_state_new == '4'">已结课</span>
                    </span>
                    <span v-else>
                      <span style="color: green" v-if="scope.row.sign_state_new == '1'">上课中</span>
                      <span v-else-if="scope.row.sign_state_new == '2'">未上课</span>
                      <span v-else-if="scope.row.sign_state_new == '3'">补课中</span>
                      <span v-else-if="scope.row.sign_state_new == '4'">已结课</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="实到/应到" key="5">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.sign_num + '/' + scope.row.total_num
                    }}</span>
                    <!-- <span v-else>--</span> -->
                  </template>
                </el-table-column>

                <el-table-column align="left" key="6" label="点名时间" prop="sign_date" show-overflow-tooltip width="180">
                </el-table-column>

                <el-table-column align="center" key="7" label="已有学员" v-if="isAllcalss1">
                  <template slot-scope="scope">
                    <span>{{ scope.row.stuTchPlanArr.length }}</span>
                  </template>
                </el-table-column>

                <el-table-column align="center" width="150" label="操作">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sign_date === null">
                      <el-button type="text" :disabled="$route.query.curriculum_class_type == 3" size="mini" @click="UpdatePlanInfo(scope.row)">编辑</el-button>
                      <el-button type="text" size="mini" @click="GoSign(scope.row)">点名
                      </el-button>
                      <el-dropdown>
                        <span class="el-dropdown-link">
                          更多
                          <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="AddStudentToPlan(scope.row)">添加学员</el-dropdown-item>
                          <el-dropdown-item @click.native="copyLectureFrequency(scope.row)">复制讲次</el-dropdown-item>
                          <el-dropdown-item @click.native="del(scope.row)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                    <span v-else>
                      <el-button :disabled="$route.query.curriculum_class_type == 3" type="text" size="mini" @click="UpdatePlanInfo(scope.row)">编辑</el-button>
                      <!-- <el-button type="text" size="mini" @click="clear(scope.row)">撤销</el-button> -->
                      <el-button type="text" size="mini" v-if="scope.row.sign_date != null" @click="num(scope.row)">详情</el-button>
                      <el-dropdown>
                        <span class="el-dropdown-link">
                          更多
                          <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="AddStudentToPlan(scope.row)">添加学员</el-dropdown-item>
                          <el-dropdown-item @click.native="copyLectureFrequency(scope.row)">复制讲次</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!--添加学员-->
      <el-dialog title="选择学员" :visible.sync="dialogVisible1" width="80%" top="5vh">
        <el-form :inline="true" size="mini">
          <el-form-item label>
            <el-input style="width: 250px" v-model="form1.realname" placeholder="请输入学员姓名"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search_student">查询</el-button>
          </el-form-item>
        </el-form>

        <div>
          <el-table size="mini" :data="Student_tableData" @selection-change="CurrentChange_Student" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column fixed="left" width="150" align="center" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.realname }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" prop="name" label="账号"></el-table-column>

            <el-table-column width="50" align="center" prop="sex" label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.sex }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="消耗方式" width="150px" v-if="is_cost_lesson_hour === false ? false : true">
              <template slot-scope="scope">
                <el-select v-model="scope.row.xm_goods_id" placeholder="请选择" size="mini">
                  <el-option v-for="item in scope.row.xmGoodsList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="" label="剩余课时" width="100px" v-if="is_cost_lesson_hour === false ? false : true">
              <template slot-scope="scope">
                <span>
                  <el-select v-model="scope.row.xm_goods_id" size="mini" disabled>
                    <el-option v-for="(item, index) in scope.row.xmGoodsList" :key="index" :label="item.remainingLessonHours.toString()" :value="item.id">
                    </el-option>
                  </el-select>
                </span>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" label="学校名称">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.school_name }}</span>
              </template>
            </el-table-column>
            <el-table-column width="150" align="center" label="在校年级">
              <template slot-scope="scope">
                <span>{{ gradeMap[scope.row.studentUserInfo.grade] }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="所在班级" width="200">
              <template slot-scope="scope">
                <div v-for="item in scope.row.stuClassArr" :key="item.id">
                  <span>{{
                    item.className
                      ? item.className
                      : item.classInfo
                      ? item.classInfo.name
                      : ''
                  }}</span>
                  <br />
                </div>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" label="联系电话">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.parent_a }}</span>
                <span>{{ scope.row.studentUserInfo.parent_a_phone_num }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" label="家长微信">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.parent_b }}</span>
                <span>{{ scope.row.studentUserInfo.parent_b_phone_num }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" label="负责人">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.leaderName }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" prop="normal_state" label="学员状态">
              <template slot-scope="scope">
                <span v-if="scope.row.normal_state == '1'">试听</span>
                <span v-else-if="scope.row.normal_state == '2'">在读</span>
                <span v-else-if="scope.row.normal_state == '3'">休学</span>
                <span v-else-if="scope.row.normal_state == '4'">已退学</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" prop="created_time" label="录入时间"></el-table-column>
          </el-table>
        </div>
        <div class="pagination-style">
          <el-pagination @current-change="handleCurrentChange9" :current-page="page_no9" :page-size="page_size9" layout="total,prev, pager, next" :total="total9"></el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible1 = false">取消</el-button>
          <el-button size="small" type="primary" @click="addStuToTeachingPlan">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="添加学员" :visible.sync="dialogTableVisible" width="80%" top="5vh" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-radio-group v-model="value2" class="changeTag" @change="checkTable" size="mini" v-if="is_cost_lesson_hour == false">
          <el-radio-button label="0">全部学员</el-radio-button>
          <el-radio-button label="1">收据学员</el-radio-button>
        </el-radio-group>
        <!-- <el-switch style="display: block" v-model="value2" active-color="rgba(24, 144, 255, 1)" inactive-color="rgba(255, 141, 26, 1)" active-text="收据学员" inactive-text="全部学员" @change="checkTable" class="changeTag"></el-switch> -->
        <el-row :gutter="20" v-if="isTableList1">
          <el-col :span="24" v-if="is_cost_lesson_hour">
            <div>
              <el-form :inline="true" size="mini" @submit.native.prevent>
                <el-form-item label="学员姓名">
                  <el-input style="width: 250px" v-model="form3.realname" placeholder="请输入学员姓名" @keyup.enter.native="search3"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search3">查询</el-button>
                </el-form-item>
              </el-form>

              <div class="table-style">
                <el-table @selection-change="handleSelectionChangegridData" :row-key="
                    (row) => {
                      return row.id
                    }
                  " style=" border: 1px solid #f5f7fa" size="mini" height="50vh" :data="gridData" :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#909399',
                  }" stripe>
                  <el-table-column v-if="is_cost_lesson_hour" type="selection" :reserve-selection="true" width="55"></el-table-column>

                  <el-table-column width="50" label="序号">
                    <template slot-scope="scope">
                      <span>{{
                        scope.$index + 1 + (page_no3 - 1) * page_size3
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="学员姓名" width="150">
                    <template slot-scope="scope">
                      <span>{{ scope.row.studentUserInfo.realname }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="left" prop="name" label="平台账号" width="150"></el-table-column>
                  <el-table-column align="left" label="消耗方式" width="150" v-if="this.is_cost_lesson_hour === true">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.xm_goods_id" placeholder="请选择" size="mini">
                        <el-option v-for="item in scope.row.xmGoodsList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="剩余课时" width="110px" v-if="this.is_cost_lesson_hour === true">
                    <template slot-scope="scope">
                      <span>
                        <div class="classHour">
                          <el-select v-model="scope.row.xm_goods_id" size="mini" disabled>
                            <el-option v-for="(item, index) in scope.row.xmGoodsList" :key="index" :label="item.remainingLessonHours.toString()" :value="item.id">
                            </el-option>
                          </el-select>
                        </div>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="所在班级" prop="class_str" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                      <div v-for="item in scope.row.stuClassArr" :key="item.id">
                        <span>{{ item.classInfo.name }}</span>
                      </div>
                    </template> -->
                  </el-table-column>

                  <el-table-column label="操作" width="100" v-if="is_cost_lesson_hour == false ? true : false">
                    <template slot-scope="scope">
                      <el-button size="mini" type="text" @click="InsertStudent(scope.$index, scope.row)">选择</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="pagination-style">
                <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="page_no3" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size3" layout="total, sizes, prev, pager, next, jumper" :total="total3"></el-pagination>
              </div>
              <div class="btnright" v-if="is_cost_lesson_hour">
                <span slot="footer" class="dialog-footer">
                  <el-button size="small" @click="CancelAdd">暂不添加</el-button>
                  <el-button size="small" type="primary" @click="addStudentClassRelationFromAll">加入班级</el-button>
                </span>
              </div>
            </div>
          </el-col>
          <el-col :span="17" v-if="is_cost_lesson_hour == false ? true : false">
            <div>
              <el-form :inline="true" size="mini" @submit.native.prevent>
                <el-form-item label="姓名:">
                  <el-input style="width: 250px" v-model="form3.realname" placeholder="请输入学员姓名" @keyup.enter.native="search3"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search3">查询</el-button>
                </el-form-item>
              </el-form>

              <div class="table-style">
                <el-table @selection-change="handleSelectionChangegridData" :row-key="
                    (row) => {
                      return row.id
                    }
                  " style=" border: 1px solid #f5f7fa" size="mini" height="60vh" :data="gridData" :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#909399',
                  }" stripe>
                  <el-table-column v-if="is_cost_lesson_hour" type="selection" :reserve-selection="true" width="55"></el-table-column>

                  <el-table-column width="50" label="序号">
                    <template slot-scope="scope">
                      <span>{{
                        scope.$index + 1 + (page_no3 - 1) * page_size3
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="学员姓名">
                    <template slot-scope="scope">
                      <span>{{ scope.row.studentUserInfo.realname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="消耗方式" width="150px" v-if="this.is_cost_lesson_hour === true">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.xm_goods_id" placeholder="请选择" size="mini">
                        <el-option v-for="item in scope.row.xmGoodsList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="剩余课时" width="110px" v-if="this.is_cost_lesson_hour === true">
                    <template slot-scope="scope">
                      <span>
                        <div class="classHour">
                          <el-select v-model="scope.row.xm_goods_id" size="mini" disabled>
                            <el-option v-for="(item, index) in scope.row.xmGoodsList" :key="index" :label="item.remainingLessonHours.toString()" :value="item.id">
                            </el-option>
                          </el-select>
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="left" prop="name" label="平台账号"></el-table-column>
                  <el-table-column align="left" prop="class_title" label="已有课程" show-overflow-tooltip>
                  </el-table-column>

                  <el-table-column label="所在班级" prop="class_str" :show-overflow-tooltip="true">
                    <!-- <template slot-scope="scope">
                      <div v-for="item in scope.row.stuClassArr" :key="item.id">
                        <span>{{ item.classInfo.name }}</span>
                      </div>
                    </template> -->
                  </el-table-column>

                  <el-table-column label="操作" width="100" v-if="is_cost_lesson_hour == false ? true : false">
                    <template slot-scope="scope">
                      <el-button size="mini" type="text" @click="InsertStudent(scope.$index, scope.row)">选择</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="pagination-style">
                <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="page_no3" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size3" layout="total, sizes, prev, pager, next, jumper" :total="total3"></el-pagination>
              </div>
              <div class="btnright" v-if="is_cost_lesson_hour">
                <span slot="footer" class="dialog-footer">
                  <el-button size="small" @click="CancelAdd">暂不添加</el-button>
                  <el-button size="small" type="primary" @click="addStudentClassRelationFromAll">加入班级</el-button>
                </span>
              </div>
            </div>
          </el-col>
          <el-col :span="7" v-if="is_cost_lesson_hour == false ? true : false">
            <div :style="{
                marginTop: is_cost_lesson_hour == false ? '0px' : '44px',
              }">
              <div>
                <el-table style="border: 1px solid #f5f7fa; margin-top: 20px" size="mini" height="60vh" :data="gridData2" :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#909399',
                  }" stripe>
                  <el-table-column align="center" width="50" label="序号" fixed="left">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="已选学员">
                    <template slot-scope="scope">
                      <span>{{ scope.row.studentUserInfo.realname }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="Deleteoutputs(scope.$index)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="btnright">
                <span slot="footer" class="dialog-footer">
                  <el-button size="small" @click="CancelAdd">暂不添加</el-button>
                  <el-button size="small" type="primary" @click="addStudentClassRelationFromAll">加入班级</el-button>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row v-if="isTableList">
          <el-form :inline="true" size="mini" @submit.native.prevent>
            <el-form-item label="姓名">
              <el-input style="width: 250px" v-model="form3.realname" placeholder="请输入学员姓名" @keyup.enter.native="search3"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search4">查询</el-button>
            </el-form-item>
          </el-form>

          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-table size="mini" ref="multipleTable" :data="tableData2" height="53vh" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionNoClassStudent" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
                <el-table-column fixed="left" type="selection" width="55"></el-table-column>
                <el-table-column align="center" width="50" label="序号" fixed="left">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="姓名">
                  <template slot-scope="scope">
                    {{ scope.row.studentUserInfo.realname }}
                  </template>
                </el-table-column>
                <el-table-column label="平台账号">
                  <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label="已有课程">
                  <template slot-scope="scope">
                    <span v-for="item of scope.row.stuClassGoodsInfoArr" :key="item.id">{{ item.receiptInfo.lession_str }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="所在班级"></el-table-column>

                <el-table-column label="选择收据" align="left">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="tableData2[scope.$index].ClassGoodsInfo" placeholder="请选择">
                      <el-option v-for="item of scope.row.stuClassGoodsInfoArr" :key="item.id" :label="
                          (Array(7).join(0) + item.receiptInfo.num).slice(-7)
                        " :value="item"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="关联状态" align="center">
                  <template slot-scope="scope">
                    <span v-if="tableData2[scope.$index].ClassGoodsInfo" style="cursor: pointer; color: #409eff" @click="
                        LookReceipt(
                          tableData2[scope.$index].ClassGoodsInfo.receiptInfo
                        )
                      ">查看</span>
                    <span v-else>未关联</span>
                  </template>
                </el-table-column>
              </el-table>

              <div class="pagination-style">
                <el-pagination @current-change="handleCurrentChange2" :current-page.sync="page_no2" layout="total, prev, pager, next" :page-size="page_size2" :total="total2"></el-pagination>
              </div>
              <div class="btnright">
                <span slot="footer" class="dialog-footer">
                  <el-button size="small" @click="dialogTableVisible = false">取消</el-button>
                  <el-button size="small" type="primary" @click="addStudentClassRelation">加入班级</el-button>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-dialog>

      <el-dialog width="80%" title="选择目标班级" :visible.sync="outerVisible2" top="5vh">
        <el-form size="mini" :inline="true" :model="changeform" ref="ruleForm" @submit.native.prevent>
          <el-form-item label="班级名称">
            <el-input style="width: 250px" clearable v-model="changeform.className" placeholder="请输入班级名称" @keyup.enter.native="search1"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search1" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>

        <div>
          <el-table size="mini" :data="stuChange_ClassList" style="width: 100%" highlight-current-row @current-change="SelectTargetClass" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe height="50vh">
            <el-table-column align="center" width="50" label="序号" fixed="left">
              <template slot-scope="scope">
                <span>{{
                  scope.$index + 1 + (page_no4 - 1) * page_size4
                }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" prop="name" label="班级名称"></el-table-column>

            <el-table-column align="left" prop="start_date" label="开课日期"></el-table-column>

            <el-table-column align="left" prop="end_date" label="结课日期"></el-table-column>

            <el-table-column align="left" label="授课时段">
              <template slot-scope="scope">
                <span>{{ scope.row.week_str }} / {{ scope.row.time_str }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="上课进度">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sign_tchplan_num }} /
                  {{ scope.row.total_tchplan_num }}
                </span>
              </template>
            </el-table-column>

            <el-table-column align="left" prop="lectureName" label="上课老师"></el-table-column>
          </el-table>

          <div style="margin-top: 20px; text-align: right">
            <el-pagination @current-change="handleCurrentChange4" :current-page="page_no4" :page-size="page_size4" layout="total,prev, pager, next" :total="total4"></el-pagination>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="outerVisible2 = false">取消</el-button>
          <el-button size="small" type="primary" @click="changeStuClass">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="收据信息" :visible.sync="DialogVisible" width="80%" top="10vh">
        <div class="dialog-body" v-if="ReceiptData.length > 0" style="margin-bottom: 20px">
          <el-table size="small" ref="classTable" :data="ReceiptData" tooltip-effect="dark" :header-cell-style="{ background: '#f1f7fe' }">
            <el-table-column align="center" label="名称" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">{{
                  scope.row.curriculumInfo.title
                }}</span>
                <span v-else-if="scope.row.type == '2'">{{
                  scope.row.goodsInfo.name
                }}</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="subject_id" label="班级"></el-table-column>

            <el-table-column align="center" prop="original_unit_price" label="原价"></el-table-column>

            <el-table-column align="center" prop="buy_num" label="数量"></el-table-column>

            <el-table-column align="center" label="单位">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">次</span>
                <span v-else-if="scope.row.type == '2'">{{
                  scope.row.goodsInfo.unit
                }}</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="discount" label="折扣(%)"></el-table-column>

            <el-table-column align="center" label="金额">
              <template slot-scope="scope">{{
                scope.row.now_unit_price * scope.row.buy_num
              }}</template>
            </el-table-column>

            <el-table-column align="center" prop="give_num" label="赠送数量"></el-table-column>
          </el-table>
        </div>

        <el-row>
          <el-col :span="12">
            <div>
              <div style="background: #f1f7fe; color: #606266; padding: 10px">
                <span style="margin-left: 5px">结算信息</span>
              </div>

              <el-row style="padding: 20px">
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <el-form size="mini" :model="Current_Receipt" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="bold: 500">
                      <el-form-item label="合计金额">
                        <span>{{ Current_Receipt.total_amount }}</span>
                      </el-form-item>

                      <el-form-item label="直减优惠">
                        <span>{{ Current_Receipt.other_amount }}</span>
                      </el-form-item>

                      <el-form-item label="应交金额">
                        <span>
                          {{
                            Current_Receipt.total_amount -
                              Current_Receipt.other_amount
                          }}
                        </span>
                      </el-form-item>

                      <el-divider></el-divider>

                      <el-form-item label="使用电子钱包">
                        <span>{{ Current_Receipt.bullet_amount }}</span>
                      </el-form-item>

                      <el-form-item label="实交金额">
                        <span>{{ Current_Receipt.final_amount }}</span>
                      </el-form-item>

                      <el-form-item label="收款账户">
                        <div v-for="item of receiptAccountList" :key="item.id">
                          <span>{{ item.accountName }}</span>
                          <span style="margin-left: 10px">{{
                            item.amount
                          }}</span>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="background: #f1f7fe; color: #606266; padding: 10px">
              <span style="margin-left: 5px">其他信息</span>
            </div>

            <el-row style="padding: 20px">
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <el-form size="mini" :model="updateform" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="交费类型">
                      <el-select size="mini" v-model="updateform.charge_type" placeholder="请选择">
                        <el-option v-for="item in shouju_type" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="发票编号">
                      <el-input v-model="updateform.fapiao"></el-input>
                    </el-form-item>

                    <el-form-item label="业绩归属人">
                      <el-select clearable v-model="updateform.leader" placeholder="请选择业绩归属人">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.realname" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="备注">
                      <el-input type="textarea" v-model="updateform.remark"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </el-col>
            </el-row>

            <div></div>
          </el-col>
        </el-row>

        <div slot="footer" style="margin-top: 20px" class="dialog-footer">
          <el-button size="small" @click="DialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
      <!--修改讲次信息-->
      <el-dialog width="660px" top="10vh" title="讲次信息" :visible.sync="dialogFormVisible7">
        <el-form size="mini" :model="updateform" ref="form" label-width="100px" label-position="left">
          <el-form-item label="讲次名称" required>
            <el-input style="width: 500px" disabled v-model="updateform.title" placeholder="请输入讲次"></el-input>
          </el-form-item>

          <el-form-item label="上课老师" required>
            <!-- :disabled="updateform.start_date" -->
            <el-select :disabled="isDisabled" style="width: 500px" v-model="updateform.lecturer_id">
              <el-option :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" v-for="(item, index) of teacherList" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上课日期" required v-if="isDisabled == true">
            <el-date-picker :disabled="isDisabled" type="date" placeholder="请选择课程开始时间" v-model="updateform.class_date" style="width: 500px" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
          </el-form-item>

          <el-form-item label="上课时段" required v-if="isDisabled == true">
            <el-time-picker :disabled="isDisabled" v-model="updateform.start_time" placeholder="选择开始时间" value-format="HH:mm:ss" placement="bottom-start">
            </el-time-picker>至
            <el-time-picker :disabled="isDisabled" v-model="updateform.end_time" placeholder="选择结束时间" value-format="HH:mm:ss" placement="bottom-start"></el-time-picker>
          </el-form-item>
          <el-form-item label="*上课日期" v-if="isDisabled == false">
            <el-date-picker :disabled="isDisabled" type="date" placeholder="请选择课程开始时间" v-model="updateform.class_date" style="width: 500px" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
          </el-form-item>

          <el-form-item label="*上课时段" v-if="isDisabled == false">
            <el-time-picker :disabled="isDisabled" v-model="updateform.start_time" placeholder="选择开始时间" value-format="HH:mm:ss" placement="bottom-start">
            </el-time-picker>至
            <el-time-picker :disabled="isDisabled" v-model="updateform.end_time" placeholder="选择结束时间" value-format="HH:mm:ss" placement="bottom-start"></el-time-picker>
          </el-form-item>
          <!-- <el-form-item label="排序号" required>
            <el-input-number :disabled="isDisabled" v-model="updateform.sort_num" :precision="2"
              :step="0.1"></el-input-number>
            <span>（修改讲次排序号，可修改上课顺序！）</span>
          </el-form-item> -->
          <div v-if="is_cost_lesson_hour">
            <el-form-item label="授课课时" required v-if="isDisabled">
              <el-input-number v-model="updateform.cost_lesson_hour" :precision="2" :step="0.1"></el-input-number>
            </el-form-item>
          </div>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible7 = false">取 消</el-button>
          <el-button size="small" type="primary" @click="updateTeachingPlan">修 改</el-button>
        </div>
      </el-dialog>

      <!-- 添加讲次 -->
      <el-dialog width="80%" top="5vh" title="添加讲次" :visible.sync="dialogFormVisible8">
        <div>
          <el-form size="mini" :inline="true" :model="form4" class="demo-form-inline" @submit.native.prevent>
            <el-form-item label="讲次名称:">
              <el-input v-model="form4.name" placeholder="请输入讲次名称" clearable @keyup.enter.native="onSubmit"></el-input>
            </el-form-item>

            <el-form-item label="所属课程:">
              <el-select v-model="form4.id" filterable placeholder="请选择" clearable @change="onSubmit">
                <el-option :label="item.title" :value="item.id" v-for="item in curriculum_list" :key="item.id"></el-option>
              </el-select>
              <!-- <el-input v-model="form4.title" placeholder="请输入课程名称" clearable @keyup.enter.native="onSubmit"></el-input> -->
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
          <div v-if="isShowmultipleSelection1" style="margin-bottom:20px">
            共 {{ multipleSelection1.length }} 节
            <el-button type="primary" @click="submitButton" size="mini" style="margin-left:10px">确认</el-button>
          </div>
          <el-row :gutter="20" v-if="isTableList1">
            <el-col :span="14">
              <div>
                <div class="table-style">
                  <el-table ref="multipleTable1" :row-key="
                      (row) => {
                        return row.id
                      }
                    " @selection-change="handleSelectionChange2" style="border: 1px solid #f5f7fa" height="60vh" size="mini" :data="gridData3" :header-cell-style="{
                      background: '#f5f7fa',
                      color: '#909399',
                    }" stripe>
                    <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>

                    <el-table-column align="center" width="50" label="序号">
                      <template slot-scope="scope">{{
                        scope.$index + 1 + (page_no5 - 1) * page_size5
                      }}</template>
                    </el-table-column>

                    <el-table-column width="80" align="left" label="封面">
                      <template slot-scope="scope">
                        <el-image style="width: 24px; height: 18px" :src="scope.row.img_url" fit="cover"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="讲次名称" align="left" prop="title"></el-table-column>

                    <el-table-column label="所属课程" align="left" prop="curriculum_title"></el-table-column>

                    <!-- <el-table-column label="课程类型" align="center" prop="subject_title"></el-table-column> -->

                    <el-table-column fixed="right" align="center" label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="InsertStudent1(scope.$index)">选择</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>

                <div class="pagination-style">
                  <el-pagination @size-change="handleSizeChange5" @current-change="handleCurrentChange5" :current-page="page_no5" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size5" layout="total, sizes, prev, pager, next, jumper" :total="total5"></el-pagination>
                </div>
              </div>
            </el-col>
            <el-col :span="10">
              <div>
                <div>
                  <el-table size="mini" :data="gridData4" height="60vh" style="width: 100%; border: 1px solid #f5f7fa" :header-cell-style="{
                      background: '#f5f7fa',
                      color: '#909399',
                    }" stripe>
                    <el-table-column type="index" align="center" width="50" label="已选"></el-table-column>
                    <el-table-column width="80" align="left" label="封面">
                      <template slot-scope="scope">
                        <el-image style="width: 24px; height: 18px" :src="scope.row.img_url" fit="cover"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="讲次名称" align="center" prop="title"></el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button type="text" @click="Deleteoutputs1(scope.$index)">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="btnright">
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dialogFormVisible8 = false">取消</el-button>
                    <el-button size="small" type="primary" @click="addStudentClassRelation1">确认添加</el-button>
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <!-- 添加补课计划 -->
      <el-dialog width="80%" top="10vh" title="添加讲次" :visible.sync="dialogFormVisible10">
        <div>
          <el-form :inline="true" :model="form4" class="demo-form-inline">
            <el-form-item label="课程名称">
              <el-input v-model="form4.title" placeholder="请输入课程名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="讲次名称">
              <el-input v-model="form4.name" placeholder="请输入讲次名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>

          <el-row :gutter="40" v-if="isTableList1">
            <el-col :span="14">
              <div>
                <div class="table-style">
                  <el-table style="border: 1px solid #f5f7fa" height="565" size="mini" :data="gridData6" :header-cell-style="{ background: '#f5f7fa' }">
                    <el-table-column type="index" align="center" width="50" label="序号"></el-table-column>
                    <el-table-column width="80" align="left" label="封面">
                      <template slot-scope="scope">
                        <el-image style="width: 24px; height: 18px" :src="scope.row.img_url" fit="cover"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="讲次名称" align="center" prop="title"></el-table-column>
                    <el-table-column label="课程介绍" align="center" prop="desc" show-overflow-tooltip></el-table-column>

                    <el-table-column label="所属课程" align="center" prop="curriculum_title"></el-table-column>

                    <!-- <el-table-column label="课程类型" align="center" prop="subject_title"></el-table-column> -->

                    <el-table-column fixed="right" align="center" label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="InsertStudent2(scope.$index)">选择</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="pagination-style">
                  <el-pagination @current-change="handleCurrentChange5" :current-page="page_no5" :page-size="page_size5" layout="total, prev, pager, next, jumper" :total="total5"></el-pagination>
                </div>
              </div>
            </el-col>
            <el-col :span="10">
              <div>
                <div>
                  <el-table size="mini" :data="gridData7" height="565" style="width: 100%; border: 1px solid #f5f7fa" :header-cell-style="{
                      background: '#f5f7fa',
                      color: '#909399',
                    }" stripe>
                    <el-table-column type="index" align="center" width="50" label="已选"></el-table-column>
                    <el-table-column width="80" align="left" label="封面">
                      <template slot-scope="scope">
                        <el-image style="width: 24px; height: 18px" :src="scope.row.img_url" fit="cover"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="讲次名称" align="center" prop="title"></el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button type="text" @click="Deleteoutputs2(scope.$index)">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="btnright">
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="dialogFormVisible8 = false">取消</el-button>
                    <el-button size="small" type="primary" @click="addStudentClassRelation2">确认添加</el-button>
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-dialog>

      <!--点名上课-->
      <el-dialog width="80%" title="点名上课" :visible.sync="dialogFormVisible9" top="5vh">
        <el-row>
          <el-col :span="4">
            <div style="line-height: 40px;">
              <span style="font-weight: bold;">讲次名称:</span>
              <span style="margin-left: 10px">{{ lessionTitle }}</span>
            </div>
          </el-col>
          <el-col :span="20">
            <el-form :model="ruleForm1" :rules="rules" ref="ruleForm1" :inline="true">
              <el-form-item label="上课日期" prop="calssData" style="margin-bottom: 0px;font-weight: bold;">
                <el-date-picker size="mini" value-format="yyyy-MM-dd" style="width: 160px;" v-model="ruleForm1.calssData" type="date" placeholder="选择日期" placement="bottom-start">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="上课时段" prop="startTime" style="margin-bottom: 0px;font-weight: bold;">
                <el-time-picker size="mini" style="width: 120px;" format="HH:mm" value-format="HH:mm:00" v-model="ruleForm1.startTime" :picker-options="{
                    selectableRange: `00:00:00 - ${
                      ruleForm1.endTime ? ruleForm1.endTime : '23:59:59'
                    }`,
                  }" placeholder="上课时间" placement="bottom-start">
                </el-time-picker>
                <span> - </span>
              </el-form-item>
              <el-form-item label="" prop="endTime" style="margin-bottom: 0px;">
                <el-time-picker format="HH:mm" value-format="HH:mm:00" size="mini" style="width: 120px;" v-model="ruleForm1.endTime" :picker-options="{
                    selectableRange: `${
                      ruleForm1.startTime ? ruleForm1.startTime : '00:00:00'
                    } - 23:59:59`,
                  }" placeholder="下课时间" placement="bottom-start">
                </el-time-picker>
              </el-form-item>
              <el-form-item label="" style="margin-bottom: 0px;">
                <span style="cursor: pointer;color: #3F9CFB;">
                  <i @click="changeselectTime" class="el-icon-date"></i>
                </span>
              </el-form-item>
              <el-form-item v-if="is_cost_lesson_hour === false ? false : true" label="授课课时" prop="cost_lesson_hour" style="margin-bottom: 0px;font-weight: bold;">
                <el-input-number @change="changeNum" size="mini" v-model="ruleForm1.cost_lesson_hour" :precision="2" :step="0.1"></el-input-number>
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="8">
            <div>
              <!-- <el-checkbox v-model="allcost" style="float: right; margin-right: 0px" @click.native="SetAllCost($event)">
                批量计费</el-checkbox> -->

              <!-- <el-checkbox v-model="allsign" style="float: right; margin-right: 20px"
                @click.native="SetAllSign($event)">批量全勤</el-checkbox> -->
            </div>
          </el-col>
        </el-row>

        <div style="margin-top: 20px">
          <el-table ref="multipleTable4" size="mini" :data="SignStudents" style="width: 100%" height="60vh" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange1">
            >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column width="50" label="序号">
              <template slot-scope="scope">
                <span>{{
                  scope.$index + 1 + (page_no11 - 1) * page_size11
                }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="姓名" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.stu_tch_plan_type == '1'">
                  {{ scope.row.studentInfo.studentUserInfo.realname }}
                </span>
                <span v-else-if="scope.row.stu_tch_plan_type == '2'">
                  {{ scope.row.studentInfo.studentUserInfo.realname }}
                  <span style="color: #e6a23c">(试听)</span>
                </span>
                <span v-else-if="scope.row.stu_tch_plan_type == '3'">
                  {{ scope.row.studentInfo.studentUserInfo.realname }}
                  <span style="color: #e6a23c">(调课)</span>
                </span>
                <span v-else-if="scope.row.stu_tch_plan_type == '4'">
                  {{ scope.row.studentInfo.studentUserInfo.realname }}
                  <span style="color: #e6a23c">(补课)</span>
                </span>
                <span v-else-if="scope.row.stu_tch_plan_type == '5'">
                  {{ scope.row.studentInfo.studentUserInfo.realname }}
                  <span style="color: #e6a23c">(临加)</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="studentInfo.name" label="平台账号" width="150"></el-table-column>
            <el-table-column prop="" label="消耗方式" width="130" v-if="is_cost_lesson_hour">
              <template slot-scope="scope">
                <span v-if="curriculumClassInfo.is_cost_lesson_hour === true">
                  <span>{{ scope.row.xmGoodsName }}</span>
                </span>
                <span v-else> -- </span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="消耗课时" width="150" v-if="is_cost_lesson_hour">
              <template slot-scope="scope">
                <span v-if="curriculumClassInfo.is_cost_lesson_hour === true">
                  <span v-if="scope.row.stu_tch_plan_type != 4">
                    <span v-if="scope.row.stu_tch_plan_type == 5">
                      <el-input-number size="mini" v-model="scope.row.cost_lesson_hour" :precision="2" :step="0.1"></el-input-number>
                    </span>
                    <span v-else>
                      <el-input-number size="mini" v-model="scope.row.stuClassRelation.lesson_hour" :precision="2" :step="0.1"></el-input-number>
                    </span>
                  </span>
                  <span v-else>
                    <el-input style="width: 75%;" v-model="scope.row.xm_miss_cost_lesson_hour" size="mini" disabled></el-input>
                    <el-tooltip class="item" effect="dark" content="原课次已扣课时，这次课无需再扣" placement="top-start">
                      <span class="el-icon-question"></span>
                      <!-- <el-button type="info" icon="el-icon-message" circle></el-button> -->
                    </el-tooltip>
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="剩余课时" width="110" v-if="is_cost_lesson_hour">
              <template slot-scope="scope">
                <span v-if="curriculumClassInfo.is_cost_lesson_hour === true">
                  <span v-if="
                      scope.row.stu_tch_plan_type != 4 &&
                        scope.row.stu_tch_plan_type != 5
                    ">
                    {{ scope.row.xm_remainTotalLessonHours }}
                  </span>
                  <span v-else>{{ scope.row.xm_remainTotalLessonHours }}</span>
                </span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="出勤状态" width="180">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.sign_state" size="mini" @change="changeSignState($event,scope.row)">
                  <el-radio-button label="1">出勤</el-radio-button>
                  <el-radio-button label="2">缺勤</el-radio-button>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column align="left" label="计费" width="150" v-if="
                curriculumClassInfo.is_cost_lesson_hour == false ? true : false
              ">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.cost_state" size="mini">
                  <el-radio-button label="1">计费</el-radio-button>
                  <el-radio-button label="2">不计费</el-radio-button>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column align="left" label="备注" width="150">
              <template slot-scope="scope">
                <el-input clearable size="mini" type="text" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>

            <el-table-column align="left" label="家长微信">
              <template slot-scope="scope">
                <span v-if="$store.state.user.schoolInfo.authorize">
                  <span v-if="scope.row.studentInfo.authorizer_openid">
                    <span>
                      <svg t="1690514644044" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4831" width="14" height="14">
                        <path d="M352.814545 385.396364m-33.512727 0a33.512727 33.512727 0 1 0 67.025455 0 33.512727 33.512727 0 1 0-67.025455 0Z" fill="#50B674" p-id="4832"></path>
                        <path d="M502.690909 384.465455m-33.512727 0a33.512727 33.512727 0 1 0 67.025454 0 33.512727 33.512727 0 1 0-67.025454 0Z" fill="#50B674" p-id="4833"></path>
                        <path d="M576.232727 534.341818m-23.272727 0a23.272727 23.272727 0 1 0 46.545455 0 23.272727 23.272727 0 1 0-46.545455 0Z" fill="#50B674" p-id="4834"></path>
                        <path d="M694.458182 536.203636m-23.272727 0a23.272727 23.272727 0 1 0 46.545454 0 23.272727 23.272727 0 1 0-46.545454 0Z" fill="#50B674" p-id="4835"></path>
                        <path d="M512 0C229.003636 0 0 229.003636 0 512s229.003636 512 512 512 512-229.003636 512-512S794.996364 0 512 0z m-87.505455 630.225455c-26.996364 0-48.407273-5.585455-75.403636-11.17091l-75.403636 37.236364 21.410909-64.232727c-53.992727-37.236364-85.643636-85.643636-85.643637-145.221818 0-102.4 96.814545-182.458182 215.04-182.458182 105.192727 0 198.283636 64.232727 216.901819 150.807273-6.516364-0.930909-13.963636-0.930909-20.48-0.93091-102.4 0-182.458182 76.334545-182.458182 170.356364 0 15.825455 2.792727 30.72 6.516363 44.683636-7.447273 0-13.963636 0.930909-20.48 0.93091z m314.647273 75.403636l15.825455 53.992727-58.647273-32.581818c-21.410909 5.585455-42.821818 11.170909-64.232727 11.170909-102.4 0-182.458182-69.818182-182.458182-155.461818s80.058182-155.461818 182.458182-155.461818c96.814545 0 182.458182 69.818182 182.458182 155.461818 0 47.476364-31.650909 90.298182-75.403637 122.88z" fill="#50B674" p-id="4836"></path>
                      </svg>
                    </span>
                  </span>
                  <span v-else>--</span>
                </span>
                <span v-else>
                  <span v-if="scope.row.studentInfo.openid">
                    <span>
                      <div style="overflow: hidden;">
                        <div style="float: left;">
                          <svg t="1690514644044" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4831" width="16" height="16">
                            <path d="M352.814545 385.396364m-33.512727 0a33.512727 33.512727 0 1 0 67.025455 0 33.512727 33.512727 0 1 0-67.025455 0Z" fill="#50B674" p-id="4832"></path>
                            <path d="M502.690909 384.465455m-33.512727 0a33.512727 33.512727 0 1 0 67.025454 0 33.512727 33.512727 0 1 0-67.025454 0Z" fill="#50B674" p-id="4833"></path>
                            <path d="M576.232727 534.341818m-23.272727 0a23.272727 23.272727 0 1 0 46.545455 0 23.272727 23.272727 0 1 0-46.545455 0Z" fill="#50B674" p-id="4834"></path>
                            <path d="M694.458182 536.203636m-23.272727 0a23.272727 23.272727 0 1 0 46.545454 0 23.272727 23.272727 0 1 0-46.545454 0Z" fill="#50B674" p-id="4835"></path>
                            <path d="M512 0C229.003636 0 0 229.003636 0 512s229.003636 512 512 512 512-229.003636 512-512S794.996364 0 512 0z m-87.505455 630.225455c-26.996364 0-48.407273-5.585455-75.403636-11.17091l-75.403636 37.236364 21.410909-64.232727c-53.992727-37.236364-85.643636-85.643636-85.643637-145.221818 0-102.4 96.814545-182.458182 215.04-182.458182 105.192727 0 198.283636 64.232727 216.901819 150.807273-6.516364-0.930909-13.963636-0.930909-20.48-0.93091-102.4 0-182.458182 76.334545-182.458182 170.356364 0 15.825455 2.792727 30.72 6.516363 44.683636-7.447273 0-13.963636 0.930909-20.48 0.93091z m314.647273 75.403636l15.825455 53.992727-58.647273-32.581818c-21.410909 5.585455-42.821818 11.170909-64.232727 11.170909-102.4 0-182.458182-69.818182-182.458182-155.461818s80.058182-155.461818 182.458182-155.461818c96.814545 0 182.458182 69.818182 182.458182 155.461818 0 47.476364-31.650909 90.298182-75.403637 122.88z" fill="#50B674" p-id="4836"></path>
                          </svg>
                        </div>
                        <div style="float: left;margin-top: -3px;margin-left: 5px;">
                          已绑定
                        </div>
                      </div>
                    </span>
                  </span>
                  <span v-else>--</span>
                </span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="推送状态">
              <template slot-scope="scope">
                <span v-if="scope.row.is_send_wx_message == true">
                  ✔️
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="推送时间" width="160">
              <template slot-scope="scope">
                {{ scope.row.send_wx_message_date }}
              </template>
            </el-table-column>

            <el-table-column width="150" align="center" label="签到时间" prop="sign_date" fixed="right">
              <template slot-scope="scope">
                <span>{{ scope.row.sign_date }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <span v-if="scope.row.stu_tch_plan_type == 4">--</span>
                <span v-else>
                  <i @click="deleteStuOfTeachingPlan(scope.row.student_user_id)" style="cursor: pointer" class="el-icon-delete"></i>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible9 = false">取 消</el-button>
          <el-button size="small" type="primary" :disabled="SignStudents.length == 0 ? true : false" @click="updateSign('ruleForm1')">提交签到信息</el-button>
        </div>
      </el-dialog>

      <!-- 缺勤列表 -->
      <el-dialog title="缺勤记录" :visible.sync="dialogVisible5" width="80%" top="5vh">
        <el-table :data="absenceFromDutyList" style="width: 100%" size="small" height="60vh" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column width="50" type="index" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="课程名称" prop="tchPlanInfo.curriculumTitle"></el-table-column>
          <el-table-column label="讲次名称" prop="tchPlanInfo.lessionTitle"></el-table-column>

          <el-table-column label="上课老师" prop="tchPlanInfo.lecturerName"></el-table-column>
          <el-table-column label="排课日期" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.tchPlanInfo.start_class_date === null" style="color: rgba(255, 141, 26, 1)">暂未排课</span>

              <span v-else>{{ scope.row.tchPlanInfo.start_class_date }} ~
                {{ scope.row.tchPlanInfo.end_class_date.split(' ')[1] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="上课时间" align="center" prop="tchPlanInfo.sign_date"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible5 = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible5 = false">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="签到信息" :visible.sync="dialogVisible9" width="80%" top="5vh">
        <el-row>
          <el-col :span="6">
            <div>
              <span style="font-weight: bold;">讲次名称:</span>
              <span style="margin-left: 10px">{{ lessionTitle }}</span>
            </div>
          </el-col>
          <el-col :span="18">
            <div style="overflow: hidden;">
              <div class="fl" style=" margin-right: 15px;">
                <span style="font-weight: bold;">上课日期:</span>
                <span style="margin-left: 10px">
                  {{ this.ruleForm1.calssData }}
                  {{ this.ruleForm1.startTime }} -
                  {{ this.ruleForm1.endTime }}</span>
              </div>
              <div class="fl" v-if="is_cost_lesson_hour != false">
                <span style="font-weight: bold;">授课课时:</span>
                <span style="margin-left: 10px">{{ ruleForm1.cost_lesson_hour }} 课时</span>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-table :data="stuPlanList1" stripe :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" style="width: 100%;margin-top: 20px;" height="60vh">
          <el-table-column width="50" label="序号">
            <template slot-scope="scope">
              <span>{{
                scope.$index + 1 + (page_no10 - 1) * page_size10
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span v-if="scope.row.stu_tch_plan_type == '1'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '2'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(试听)</span>
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '3'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(调课)</span>
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '4'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(补课)</span>
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '5'">
                {{ scope.row.studentInfo.studentUserInfo.realname }}
                <span style="color: #e6a23c">(临加)</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.studentInfo.studentUserInfo.sex }}</span>
            </template>
          </el-table-column>
          <el-table-column label="账号" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.studentInfo.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="消耗方式" width="140" v-if="is_cost_lesson_hour">
            <template slot-scope="scope">
              <span v-if="curriculumClassInfo1.is_cost_lesson_hour === true">
                <span>{{ scope.row.xmGoodsName }}</span>
              </span>
              <span v-else> -- </span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="扣除额度" width="150" v-if="is_cost_lesson_hour">
            <template slot-scope="scope">
              <span v-if="curriculumClassInfo1.is_cost_lesson_hour === true">
                <span v-if="scope.row.isShowInput === true">
                  <el-input-number size="mini" v-model="scope.row.cost_lesson_hour1" :precision="2" :step="0.1"></el-input-number>
                </span>
                <span v-else>
                  <span>{{ scope.row.cost_lesson_hour }}</span>
                  <span v-if="
                      scope.row.over_lesson_hour != 0 &&
                        scope.row.over_lesson_hour != null
                    " style="color: #f00; margin-left: 10px;font-size: 12px;">(超上{{ scope.row.over_lesson_hour }}课时)</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="剩余课时" width="110" v-if="is_cost_lesson_hour">
            <template slot-scope="scope">
              <span v-if="curriculumClassInfo1.is_cost_lesson_hour === true">
                <span v-if="
                    scope.row.stu_tch_plan_type != 4 &&
                      scope.row.stu_tch_plan_type != 5
                  ">
                  {{ scope.row.xm_remainTotalLessonHours }}
                </span>
                <span v-else>{{ scope.row.xm_remainTotalLessonHours }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="出勤状态" width="150">
            <template slot-scope="scope">
              <span>
                <span v-if="scope.row.isShowInput === true">
                  <el-radio-group @change="changeSignState($event,scope.row)" v-model="scope.row.sign_state" size="mini" :disabled="
                      scope.row.xm_miss_state == 3 ||
                        scope.row.xm_miss_state == 4
                    ">
                    <el-radio-button label="1">出勤</el-radio-button>
                    <el-radio-button label="2">缺勤</el-radio-button>
                  </el-radio-group>
                </span>
                <span v-else>
                  <span v-if="scope.row.sign_state == '1'">出勤</span>
                  <span v-if="scope.row.sign_state == '2'">缺勤</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="计费" width="150" v-if="
              curriculumClassInfo1.is_cost_lesson_hour == false ? true : false
            ">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.cost_state == 1">计费</span>
              <span v-if="scope.row.cost_state == 2">不计费</span> -->
              <span>
                <span v-if="scope.row.isShowInput === true">
                  <el-radio-group v-model="scope.row.cost_state" size="mini">
                    <el-radio-button label="1">计费</el-radio-button>
                    <el-radio-button label="2">不计费</el-radio-button>
                  </el-radio-group>
                </span>
                <span v-else>
                  <span v-if="scope.row.cost_state == '1'">计费</span>
                  <span v-if="scope.row.cost_state == '2'">不计费</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="家长微信">
            <template slot-scope="scope">
              <span v-if="$store.state.user.schoolInfo.authorize">
                <span v-if="scope.row.studentInfo.authorizer_openid">
                  <span>
                    <svg t="1690514644044" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4831" width="14" height="14">
                      <path d="M352.814545 385.396364m-33.512727 0a33.512727 33.512727 0 1 0 67.025455 0 33.512727 33.512727 0 1 0-67.025455 0Z" fill="#50B674" p-id="4832"></path>
                      <path d="M502.690909 384.465455m-33.512727 0a33.512727 33.512727 0 1 0 67.025454 0 33.512727 33.512727 0 1 0-67.025454 0Z" fill="#50B674" p-id="4833"></path>
                      <path d="M576.232727 534.341818m-23.272727 0a23.272727 23.272727 0 1 0 46.545455 0 23.272727 23.272727 0 1 0-46.545455 0Z" fill="#50B674" p-id="4834"></path>
                      <path d="M694.458182 536.203636m-23.272727 0a23.272727 23.272727 0 1 0 46.545454 0 23.272727 23.272727 0 1 0-46.545454 0Z" fill="#50B674" p-id="4835"></path>
                      <path d="M512 0C229.003636 0 0 229.003636 0 512s229.003636 512 512 512 512-229.003636 512-512S794.996364 0 512 0z m-87.505455 630.225455c-26.996364 0-48.407273-5.585455-75.403636-11.17091l-75.403636 37.236364 21.410909-64.232727c-53.992727-37.236364-85.643636-85.643636-85.643637-145.221818 0-102.4 96.814545-182.458182 215.04-182.458182 105.192727 0 198.283636 64.232727 216.901819 150.807273-6.516364-0.930909-13.963636-0.930909-20.48-0.93091-102.4 0-182.458182 76.334545-182.458182 170.356364 0 15.825455 2.792727 30.72 6.516363 44.683636-7.447273 0-13.963636 0.930909-20.48 0.93091z m314.647273 75.403636l15.825455 53.992727-58.647273-32.581818c-21.410909 5.585455-42.821818 11.170909-64.232727 11.170909-102.4 0-182.458182-69.818182-182.458182-155.461818s80.058182-155.461818 182.458182-155.461818c96.814545 0 182.458182 69.818182 182.458182 155.461818 0 47.476364-31.650909 90.298182-75.403637 122.88z" fill="#50B674" p-id="4836"></path>
                    </svg>
                  </span>
                </span>
                <span v-else>--</span>
              </span>
              <span v-else>
                <span v-if="scope.row.studentInfo.openid">
                  <span>
                    <div style="overflow: hidden;">
                      <div style="float: left;">
                        <svg t="1690514644044" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4831" width="16" height="16">
                          <path d="M352.814545 385.396364m-33.512727 0a33.512727 33.512727 0 1 0 67.025455 0 33.512727 33.512727 0 1 0-67.025455 0Z" fill="#50B674" p-id="4832"></path>
                          <path d="M502.690909 384.465455m-33.512727 0a33.512727 33.512727 0 1 0 67.025454 0 33.512727 33.512727 0 1 0-67.025454 0Z" fill="#50B674" p-id="4833"></path>
                          <path d="M576.232727 534.341818m-23.272727 0a23.272727 23.272727 0 1 0 46.545455 0 23.272727 23.272727 0 1 0-46.545455 0Z" fill="#50B674" p-id="4834"></path>
                          <path d="M694.458182 536.203636m-23.272727 0a23.272727 23.272727 0 1 0 46.545454 0 23.272727 23.272727 0 1 0-46.545454 0Z" fill="#50B674" p-id="4835"></path>
                          <path d="M512 0C229.003636 0 0 229.003636 0 512s229.003636 512 512 512 512-229.003636 512-512S794.996364 0 512 0z m-87.505455 630.225455c-26.996364 0-48.407273-5.585455-75.403636-11.17091l-75.403636 37.236364 21.410909-64.232727c-53.992727-37.236364-85.643636-85.643636-85.643637-145.221818 0-102.4 96.814545-182.458182 215.04-182.458182 105.192727 0 198.283636 64.232727 216.901819 150.807273-6.516364-0.930909-13.963636-0.930909-20.48-0.93091-102.4 0-182.458182 76.334545-182.458182 170.356364 0 15.825455 2.792727 30.72 6.516363 44.683636-7.447273 0-13.963636 0.930909-20.48 0.93091z m314.647273 75.403636l15.825455 53.992727-58.647273-32.581818c-21.410909 5.585455-42.821818 11.170909-64.232727 11.170909-102.4 0-182.458182-69.818182-182.458182-155.461818s80.058182-155.461818 182.458182-155.461818c96.814545 0 182.458182 69.818182 182.458182 155.461818 0 47.476364-31.650909 90.298182-75.403637 122.88z" fill="#50B674" p-id="4836"></path>
                        </svg>
                      </div>
                      <div style="float: left;margin-top: -3px;margin-left: 5px;">
                        已绑定
                      </div>
                    </div>
                  </span>
                </span>
                <span v-else>--</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="推送状态">
            <template slot-scope="scope">
              <span v-if="scope.row.is_send_wx_message == true">
                ✔️
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="推送时间" width="160">
            <template slot-scope="scope">
              {{ scope.row.send_wx_message_date }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isShowInput" type="text" @click="submitUpdata(scope.row)">保存</el-button>
              <el-button v-if="scope.row.isShowInput" type="text" @click="clearUpdata(scope.row)">取消</el-button>

              <el-button v-else type="text" @click="editUpdata(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible9 = false">取 消</el-button>
          <el-button size="small" @click="notice">微信通知<i class="el-icon-s-promotion el-icon--right"></i></el-button>

          <el-button size="small" type="danger" @click="clear1">撤销点名</el-button>
        </div>
        <!-- <div class="pagination-style">
          <el-pagination @size-change="handleSizeChange10" @current-change="handleCurrentChange10"
            :current-page="page_no10" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size10"
            layout="total, sizes, prev, pager, next, jumper" :total="total10"></el-pagination>
        </div> -->
      </el-dialog>
      <el-dialog title="选择时间" :visible.sync="isShowTime" width="30%" top="10vh">
        <el-select v-if="isShowTime" size="mini" style="margin-left: 20px;width: 88%;" v-model="selectTime" cleatable>
          <el-option v-for="(item, index) in selectTimeList" :key="index" :label="item" :value="item">
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="isShowTime = false">取消</el-button>
          <el-button size="small" type="primary" @click="submitTime">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="微信通知" :visible.sync="noticeShow" width="80%" top="5vh" :before-close="noticeShowclisk">
        <el-form ref="formNotice" :inline="true" :model="formNotice" label-width="80px">
          <el-form-item label="出勤状态">
            <el-select v-model="formNotice.sign_state" placeholder="请选择出勤状态" clearable size="mini">
              <el-option label="出勤" value="1"></el-option>
              <el-option label="缺勤" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送状态">
            <el-select size="mini" v-model="formNotice.is_send_wx_message" placeholder="请选择推送状态" clearable>
              <el-option label="已推送" value="3"></el-option>
              <el-option label="未推送" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-table ref="multipleTableNotice" :data="tableDataNotice2" :header-cell-style="{
            background: '#f5f7fa',
            color: '#909399',
            'font-size': '14px',
          }" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChangeNotice" height="60vh">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="left" label="姓名">
            <template slot-scope="scope">
              <span v-if="scope.row.stu_tch_plan_type == '1'">{{ scope.row.studentInfo.studentUserInfo.realname }}
              </span>
              <span v-else-if="scope.row.stu_tch_plan_type == '2'">{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(试听)</span></span>
              <span v-else-if="scope.row.stu_tch_plan_type == '3'">{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(调课)</span></span>
              <span v-else-if="scope.row.stu_tch_plan_type == '4'">{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(补课)</span></span>
              <span v-else-if="scope.row.stu_tch_plan_type == '5'">{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(临加)</span></span>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="studentInfo.name" label="平台账号" width="150"></el-table-column>
          <el-table-column align="left" label="出勤状态" width="150">
            <template slot-scope="scope">
              <span>
                <span v-if="scope.row.sign_state == '1'">出勤</span>
                <span v-if="scope.row.sign_state == '2'">缺勤</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="推送状态">
            <template slot-scope="scope">
              <span v-if="scope.row.is_send_wx_message == 3">
                ✔️
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="推送时间" width="170">
            <template slot-scope="scope">
              {{ scope.row.send_wx_message_date }}
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="noticeShowclisk">取消</el-button>
          <el-button size="small" type="primary" @click="sendSignTemplateMessage">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog title="提示" :visible.sync="lectureFrequency" width="20%" center>
      <div style="width: 100%;text-align: center;">
        <span>复制讲次是否保留学生作品</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lectureFrequencyfalse"> 不保留 </el-button>
        <el-button type="primary" @click="lectureFrequencytrue">
          保留</el-button>
      </span>
    </el-dialog>
    <el-dialog title="标记上课日" :visible.sync="dialogVisiblecalendar" width="400px">
      <el-select v-model="weekList" multiple placeholder="请选择" style="width: 100%;">
        <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblecalendar = false">取 消</el-button>
        <el-button type="primary" @click="submitalendarList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // getCampusCurriculumtListByPage,
  getCurriculumListForClassAddLesson,
  getTeachingPlanStuList,
  updateTchPlanSignState,
  deleteStuOfTeachingPlan,
  updateStuTeachingPlanSignInfo,
  // lessonList,
  getLessonListForClassAddLesson,
  // isCreate,
  toClass,
  getPlan,
  updateTeachingPlan,
  getClassStudentList,
  // getCampusTeacherList,
  getNotDivideStudentList,
  addStudentClassRelation,
  // getFormalStudentList,
  getNoXmStuForClassAddStu,
  delStudentClassRelation,
  getClassListForStuChangeClass,
  changeStuClass,
  getReceiptChargeGoodsList,
  getReceiptAccountList,
  getCampusUserList,
  getFormalStudentListForAddToTchPlan,
  addStuToTeachingPlan,
  delTchPlan,
  clearTchPlan,
  updateStuClassCostXmGoods,
  getStuListForAddStuToClass,
  getStuListForAddStuToTchPlan,
  copyTchPlanToClass,
  sendSignTemplateMessage,
  getBaseInfo,
  updateClassWeekJson,
} from '@/api/educational'
import {
  api_eduCampusSelectTchListByCampus,
  api_schoolStarGrantSignGrant,
} from '@/api/javaApi'

import moment from 'moment'

import { gradeMap } from '@/utils/enum'

export default {
  name: 'divide-class',

  data() {
    return {
      gradeMap: gradeMap,
      dialogVisiblecalendar: false,
      weekStyle: '--',
      options: [
        {
          id: '1',
          title: '周一',
        },
        {
          id: '2',
          title: '周二',
        },
        {
          id: '3',
          title: '周三',
        },
        {
          id: '4',
          title: '周四',
        },
        {
          id: '5',
          title: '周五',
        },
        {
          id: '6',
          title: '周六',
        },
        {
          id: '7',
          title: '周日',
        },
      ],
      weekList: [],
      isShowmultipleSelection1: false,
      multipleSelection1: [],
      tchPlanId: '',
      lectureFrequency: false,
      formNotice: {
        sign_state: '',
        is_send_wx_message: '',
      },
      searchData1: [],
      tableDataNotice1: [],
      multipleTableNotice: [],
      tableDataNotice: [],
      noticeShow: false,

      isShowTime: false,
      selectTime: '',
      selectTimeList: [],

      col: 17,
      multipleSelection: [],
      start_class_date1: '',
      calssDate: '',
      startCalssdate: '',
      signDate: null,
      lessionTitle: '',
      // startTime: '',
      // endTime: '',
      stuList: [],
      isSign: false,
      isDisabled: false,
      ruleForm1: {
        cost_lesson_hour: 0,
        startTime: '',
        endTime: '',
        calssData: '',
        classTime: [],
      },
      lesson_hour: 0,
      curriculumClassInfo: {},
      curriculumClassInfo1: {},

      xmGoodsId: '',
      curriculum_list: [],
      page_no10: 1,
      page_size10: 500,
      total10: 0,
      dialogVisible9: false,
      stuPlanList1: [],
      //补课计划添加
      dialogFormVisible10: false,
      //
      shouldArrivenum: '',
      realTo: '',
      numList: [],
      numListPlus: [],
      //缺勤
      dialogVisible5: false,
      absenceFromDutyList: [],

      //点名
      page_no11: 1,
      page_size11: 10,
      total11: 0,
      isShow: true,
      isButtton: true,
      SignStudents: [], //签到学员信息=
      //签到学员列表
      signStus: [],
      allcost: false,
      allsign: false,
      dialogFormVisible9: false,
      //签到班级信息
      SignClassInfo: {
        classInfo: { name: '' },
        start_class_date: '',
        end_class_date: '',
      },
      //添加讲次
      dialogFormVisible8: false,
      form4: {
        id: '',
        title: '',
        name: '',
      },
      name: '',
      gridData3: [],
      gridData4: [],
      gridData6: [],
      gridData7: [],

      //排课不排课
      isAllcalss: true,
      isAllcalss1: false,
      value1: JSON.parse(sessionStorage.getItem('courseArranging'))
        .is_create_timetable,
      dialogFormVisible7: false,
      tchPlanIds: [], //删除的讲次id组
      tchPlanInfos: [], //选择的讲次
      //添加学员相关
      form1: {}, //选择学员查询按钮
      Student_tableData: [],
      current_teachplan_id: '', //当前教学计划ID
      teachplan_form: {
        title: '', //讲次名称
        educational_institution_campus_id: '',
        classname: '', //班级名称
        week: [], //星期
        time: [], //时段 上下午 晚上
        latest: true,
        sign_state: '', //开课状态
        default_time: '', //默认时间
        date: [],
        lecturer_id: '', // 上课老师
      },

      stu_tch_plan_type: '', //临调状态
      dialogVisible1: false,
      isTableList: false,
      isTableList1: true,

      value2: '0', //是否缴费
      tableData1: [], //排课列表
      widthTable: 220,
      tableData5: [], //补课列表
      activeName: 'first',
      tableData: [], //在班学员
      page_no: 1,
      page_size: 20,
      total: 0,
      page_no6: 1,
      page_size6: 10,
      total6: 0,

      //已缴费学员
      dialogFormVisible2: false, //已缴费学员
      tableData2: [],
      page_no2: 1,
      page_size2: 20,
      total2: 0,
      NoClassStudents1: [],
      studentDataArr1: [],
      NoClassStudents: [], //选择未入班学员
      studentDataArr: [],
      teacherList: [], //教师列表
      teacherListTo: [], //助教列表

      //添加更多学员
      dialogTableVisible: false,
      form3: {
        realname: '',
        leader: '',
        phone_a_num: '',
        normal_state: '',
      },
      gridData: [], //正式学员
      gridData2: [], //选择的正式学员
      page_no3: 1,
      page_size3: 20,
      total3: 0,
      page_no9: 1,
      page_size9: 20,
      total9: 0,

      //班级移除学员
      OutClassStudents: [],
      outstudentIds: [],

      //学员调班
      current_student: '',
      current_student_id: '',

      page_no4: 1,
      page_size4: 20,
      total4: 0,
      page_no5: 1,
      page_size5: 20,
      total5: 0,
      outerVisible2: false,
      stuChange_ClassList: [],
      changeform: {
        className: '',
      },
      target_change_class: {},

      //查看收据
      DialogVisible: false,
      updateform: {
        sort_num: '00.00',
        cost_lesson_hour: 0,
        name: '',
        title: '',
        lecturer_id: '',
        educational_institution_campus_id: '',
        class_date: '',
        value: [],
        teaching_plan_id: '',
        start_time: '',
        end_time: '',
      },
      ReceiptData: [],
      teachingPlanId: '',
      Current_Receipt: {},
      shouju_type: [
        {
          id: 1,
          name: '新增',
        },
        {
          id: 2,
          name: '扩科',
        },
        {
          id: 3,
          name: '续费',
        },
        {
          id: 4,
          name: '预存',
        },
      ],
      ischeckout: JSON.parse(sessionStorage.getItem('courseArranging'))
        .is_create_timetable,
      user_list: [],
      receiptAccountList: [],
      gettime: '',
      is_cost_lesson_hour: false,
      //接收传值
      searchForm: {
        campun_name: '',
      },
      rules: {
        cost_lesson_hour: [
          { required: true, message: '请输入授课课时', trigger: 'change' },
        ],
        calssData: [
          { required: true, message: '请输入上课时间', trigger: 'change' },
        ],
        startTime: [
          { required: true, message: '请输入上课时段', trigger: 'change' },
        ],
        endTime: [
          { required: true, message: '请输入下课时段', trigger: 'change' },
        ],
      },
      showGrant: false,
    }
  },
  computed: {
    tableDataNotice2() {
      if (!this.formNotice.sign_state && !this.formNotice.is_send_wx_message) {
        return this.tableDataNotice
      }
      return this.tableDataNotice.filter((item) => {
        if (!this.formNotice.sign_state) {
          return item.is_send_wx_message == this.formNotice.is_send_wx_message
        }
        if (!this.formNotice.is_send_wx_message) {
          return item.sign_state == this.formNotice.sign_state
        }
        return (
          item.sign_state == this.formNotice.sign_state &&
          item.is_send_wx_message == this.formNotice.is_send_wx_message
        )
      })
    },
  },
  watch: {
    SignStudents: {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable4.doLayout()
        })
      },
      deep: true,
    },
    stuList: {
      handler: function (val, oldvalvue) {
        console.log(val, 123323)
        console.log(oldvalvue, 123323)
        this.chooseStudent_current = []
        for (let k = 0; k < val.length; k++) {
          this.chooseStudent_current.push({
            stuId: val[k].id,
            xm_goods_id: val[k].xm_goods_id,
          })
        }
      },
      deep: true,
    },
  },

  created() {
    // if (
    //   JSON.parse(sessionStorage.getItem("courseArranging"))
    //     .is_create_timetable === true
    // ) {
    //   this.isAllcalss = true;
    //   this.isAllcalss1 = false;
    //   this.isButtton = true;
    // } else {
    //   this.isAllcalss = false;
    //   this.isAllcalss1 = true;
    //   this.isButtton = false;
    // }
    this.info()

    // console.log(
    //   JSON.parse(sessionStorage.getItem("courseArranging")),
    //   888888888888877
    // );
    this.weekList = JSON.parse(
      sessionStorage.getItem('courseArranging')
    ).week_json
    if (this.weekList) {
      let arr = []
      console.log(this.weekList, 1254)
      this.options.map((item) => {
        this.weekList.map((item1) => {
          if (item.id == item1) {
            arr.push(item.title)
          }
        })
      })
      if (arr.length != 0) {
        this.weekStyle = arr.join(' , ')
      }
      console.log(this.weekStyle, 1245)
    }
  },

  async mounted() {
    this.ruleForm1.cost_lesson_hour = this.$route.query.lesson_hour

    const ruleRes = await this.$store.dispatch('schoolEduCampusStarRule', {
      eduCampusId: this.$store.state.user.selected_schools[0],
      ruleType: 4,
    })
    this.showGrant = ruleRes.flag
    // classTime
    this.getClassStudentList()
    this.getCampusTeacherList()
    this.getPlan()
    this.getPlan1()
    this.getTime()

    this.is_cost_lesson_hour = this.$route.query.is_cost_lesson_hour
    if (this.is_cost_lesson_hour === 'false') {
      this.is_cost_lesson_hour = false
      this.col = 17
    }
    if (this.is_cost_lesson_hour === 'true') {
      this.is_cost_lesson_hour = true
      this.col = 24
    }
    console.log(this.is_cost_lesson_hour, 789854)
  },

  methods: {
    colChange(newWidth, oldWidth, column, event) {
      console.log(newWidth, oldWidth, column, event)
      localStorage.setItem('testTabelwidth', JSON.stringify(newWidth))
    },
    submitalendarList() {
      updateClassWeekJson({
        classId: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        week_json: JSON.stringify(this.weekList),
      }).then((res) => {
        console.log(res)
        console.log(this.weekList, 123456)
        let arr = []
        console.log(this.weekList, 1254)
        this.options.map((item) => {
          this.weekList.map((item1) => {
            if (item.id == item1) {
              arr.push(item.title)
            }
          })
        })
        if (arr.length != 0) {
          this.weekStyle = arr.join(' , ')
        }
        this.$message.success('修改成功')
        this.dialogVisiblecalendar = false
      })
    },
    editTime() {
      this.dialogVisiblecalendar = true
    },
    lectureFrequencyfalse() {
      copyTchPlanToClass({
        tchPlanId: this.tchPlanId,
        operate_state: 2,
      }).then((res) => {
        console.log(res)
        this.getPlan()
        this.getPlan1()
        this.lectureFrequency = false
      })
    },
    lectureFrequencytrue() {
      copyTchPlanToClass({
        tchPlanId: this.tchPlanId,
        operate_state: 1,
      }).then((res) => {
        console.log(res)
        this.getPlan()
        this.getPlan1()
        this.lectureFrequency = false
      })
    },
    copyLectureFrequency(row) {
      console.log(row, 123456)
      this.tchPlanId = row.id
      this.lectureFrequency = true
    },
    //家校通-发送签到消息
    sendSignTemplateMessage() {
      console.log('发送家校通,通知')
      console.log(this.signStus)
      console.log(this.multipleTableNotice)
      var stuTchPlanIdArr = []
      if (this.$store.state.user.schoolInfo.authorize) {
        this.multipleTableNotice.map((item) => {
          console.log(item, 789456)
          if (item.studentInfo.authorizer_openid != '') {
            stuTchPlanIdArr.push(item.id)
          }
        })
      } else {
        this.multipleTableNotice.map((item) => {
          console.log(item, 789456)
          if (item.studentInfo.openid != '') {
            stuTchPlanIdArr.push(item.id)
          }
        })
      }
      if (this.multipleTableNotice.length == 0) {
        this.$message.warning('请选择学员')
        return false
      }
      console.log(stuTchPlanIdArr, 123456)
      sendSignTemplateMessage({
        stuTchPlanIdArr: JSON.stringify(stuTchPlanIdArr),
      }).then((res) => {
        console.log('发送签到消息')
        console.log(res)
        if (res.is_send) {
          this.$message.success('微信通知,已发送')
          this.noticeShow = false
          getTeachingPlanStuList({
            teachingPlanId: this.teachingPlanId,
            page_no: this.page_no10,
            page_size: this.page_size10,
          }).then((res) => {
            console.log(res, 456656123)
            this.curriculumClassInfo1 = res.curriculumClassInfo
            res.stuPlanList.map((item) => {
              item.isShowInput = false
              if (item.cost_lesson_hour == null) {
                item.cost_lesson_hour = 0
              }
              item.cost_lesson_hour1 = 0
              item.cost_lesson_hour1 =
                item.cost_lesson_hour + item.over_lesson_hour
              item.ItemConstLessonHour = item.cost_lesson_hour
              item.ItemConstLessonHour1 = item.cost_lesson_hour1
            })

            this.stuPlanList1 = res.stuPlanList
            console.log(this.stuPlanList1, 45412)

            this.total10 = res.total
          })
        }
      })
    },
    handleSelectionChangeNotice(val) {
      console.log(val)
      this.multipleTableNotice = val
    },

    notice() {
      this.formNotice.sign_state = ''
      this.formNotice.is_send_wx_message = ''
      let SignStudents1 = []
      this.stuPlanList1.map((item) => {
        if (item.sign_state == 1 || item.sign_state == 2) {
          if (
            item.studentInfo.authorizer_openid != '' ||
            item.studentInfo.openid != ''
          ) {
            SignStudents1.push(item)
          }
        }
      })
      console.log(SignStudents1, 123456)
      this.tableDataNotice1 = []
      this.tableDataNotice = []

      this.tableDataNotice1 = SignStudents1

      this.tableDataNotice1.map((item) => {
        if (item.is_send_wx_message == true) {
          item.is_send_wx_message = '3'
        } else {
          item.is_send_wx_message = '4'
        }
      })
      this.tableDataNotice = this.tableDataNotice1
      this.noticeShow = true
    },
    noticeShowclisk() {
      console.log(this.stuPlanList1, 123456)
      this.stuPlanList1.map((item) => {
        if (item.is_send_wx_message == '3') {
          item.is_send_wx_message = true
        } else {
          item.is_send_wx_message = false
        }
      })
      this.noticeShow = false
    },

    submitTime(val) {
      console.log(val, 123456)
      if (!this.selectTime) {
        return this.$message.error('请选择时间')
      }
      this.ruleForm1.startTime = this.selectTime.slice(0, 5) + ':00'
      this.ruleForm1.endTime = this.selectTime.slice(6, 12) + ':00'
      this.isShowTime = false
    },
    changeselectTime() {
      this.getBaseInfo()
      this.isShowTime = true
    },

    getBaseInfo() {
      this.selectTime = ''
      getBaseInfo().then((res) => {
        this.selectTimeList = []

        for (let key of res.educational_institution_class_day_list) {
          this.selectTimeList.push(
            `${key.start_class_date.slice(0, 5)}~${key.end_class_date.slice(
              0,
              5
            )}`
          )
        }

        this.$forceUpdate()
      })
    },

    selectable(row) {
      if (row.sign_date != null) {
        return false
      }

      return true
    },
    changeNum(val) {
      console.log(val)
      this.SignStudents.map((item) => {
        if (item.stu_tch_plan_type != 4 && item.stu_tch_plan_type != 5) {
          item.stuClassRelation.lesson_hour = val
        }
        if (item.stu_tch_plan_type === 5) {
          item.cost_lesson_hour = val
        }
      })
      // ruleForm1
    },
    clearUpdata(row) {
      row.isShowInput = false
    },
    editUpdata(row) {
      console.log(row, 78965)
      this.signDate = row.sign_state
      row.cost_lesson_hour1 = row.cost_lesson_hour + row.over_lesson_hour
      row.ItemConstLessonHour1 = row.cost_lesson_hour1
      row.isShowInput = true
    },
    changeSignState(val, item) {
      console.log(val, 45455)
      // 计课时班级缺勤的学生是否扣除课时
      const xmClassMissSign = this.$store.state.user.schoolInfo.xmClassMissSign;
      // 不计课时班级点名签到是否计费
      const noXmClassSign = this.$store.state.user.schoolInfo.noXmClassSign;
      // 不计课时班级缺勤学生是否计费
      const noXmClassMissSign = this.$store.state.user.schoolInfo.noXmClassMissSign;
      if (val == 1) { // 如果选出勤
        // 如果是不按课时班级，判断点名签到是否计费，为true时默认为计费，false不计费
        item.cost_lesson_hour = item.ItemConstLessonHour;
        item.cost_lesson_hour1 = item.ItemConstLessonHour1
        if (item.stuClassRelation) {
          item.stuClassRelation.lesson_hour = item.ItemStuClassRelationLessonHour
        }
        if (item.stu_tch_plan_type === 5) {
          item.cost_lesson_hour = this.ruleForm1.cost_lesson_hour
          item.cost_lesson_hour1 = this.ruleForm1.cost_lesson_hour
        }
        item.cost_state = noXmClassSign ? 1 : 2;
      } else if (val == 2) { // 否则，如果选缺勤
        // 如果是不按课时班级，判断缺勤学生是否计费，为true时默认为计费，false不计费
        // 如果是记课时班级，判断缺勤的学生是否扣除【课时】，为true时为扣除，false不扣除
        item.cost_state = noXmClassMissSign ? 1 : 2;
        item.cost_lesson_hour = xmClassMissSign ? item.cost_lesson_hour : 0
        item.cost_lesson_hour1 = xmClassMissSign ? item.cost_lesson_hour1 : 0
        if (item.stuClassRelation) {
          item.stuClassRelation.lesson_hour = xmClassMissSign ? item.stuClassRelation.lesson_hour : 0
        }
        if (item.stu_tch_plan_type === 5) {
          item.cost_lesson_hour = xmClassMissSign ? this.ruleForm1.cost_lesson_hour : 0
          item.cost_lesson_hour1 = xmClassMissSign ? this.ruleForm1.cost_lesson_hour : 0
        }
      }
      this.signDate = val
    },
    submitUpdata(row) {
      console.log(row, 45455)
      console.log(this.signDate, 45455)
      this.methodGrant({
        stuId: row.student_user_id,
        sign_state: row.sign_state,
      })
      row.isShowInput = false

      if (this.signDate === null) {
        this.$message.warning('出勤状态不能为空')
      } else {
        console.log(row, 784656)
        this.current_teachplan_id = row.teaching_plan_id
        console.log(this.curriculumClassInfo1, 7656)
        if (this.curriculumClassInfo1.is_cost_lesson_hour === true) {
          if (row.cost_xm_goods_id == null) {
            this.$message.warning('请选择消耗方式')
            return false
          }
          this.stuSignInfoList = []
          if (row.stu_tch_plan_type === 5) {
            const sign_stu = {
              stuTchPlanId: row.id,
              cost_state: '1',
              sign_state: row.sign_state,
              total_cost_lesson_hour: row.cost_lesson_hour1,
              not_come_reason: row.not_come_reason,
              remark: row.remark,
              cost_xm_goods_id: row.cost_xm_goods_id,
            }
            this.stuSignInfoList.push(sign_stu)
          } else if (row.stu_tch_plan_type === 4) {
            const sign_stu = {
              stuTchPlanId: row.id,
              cost_state: '1',
              sign_state: row.sign_state,
              total_cost_lesson_hour: row.cost_lesson_hour1,
              not_come_reason: row.not_come_reason,
              remark: row.remark,
              cost_xm_goods_id: row.cost_xm_goods_id,
            }
            this.stuSignInfoList.push(sign_stu)
          } else {
            const sign_stu = {
              stuTchPlanId: row.id,
              cost_state: '1',
              sign_state: row.sign_state,
              total_cost_lesson_hour: row.cost_lesson_hour1,
              not_come_reason: row.not_come_reason,
              remark: row.remark,
              cost_xm_goods_id: row.cost_xm_goods_id,
            }
            this.stuSignInfoList.push(sign_stu)
          }
          console.log(this.stuSignInfoList, 1234)
          console.log('转化后的学员信息')
          this.updateStuTeachingPlanSignInfo1()
        } else {
          this.stuSignInfoList = []
          const sign_stu = {
            stuTchPlanId: row.id,
            cost_state: row.cost_state,
            sign_state: row.sign_state,
            not_come_reason: row.not_come_reason,
            remark: row.remark,
          }
          this.stuSignInfoList.push(sign_stu)
          this.updateStuTeachingPlanSignInfo()
        }
      }
    },
    changeWay(row, xmGoodsId) {
      console.log(row, xmGoodsId)
      updateStuClassCostXmGoods({
        stuUserClassRelationId: row.id,
        xm_goods_id: xmGoodsId,
      }).then(() => {
        this.$message.success('修改成功')
      })
    },
    chengeList() {
      this.curriculum_list.map((item) => {
        console.log(item, 9999)
      })
    },
    //获取学校公开课课程体系
    async getCampusCurriculumtListByPage() {
      this.curriculum_list = []

      console.log('获取学校课程体系')
      console.log(this.ruleForm)

      const res = await getCurriculumListForClassAddLesson({
        // campusIds: JSON.stringify([this.$route.query.campus_id]),
        userId: this.$route.query.lecturer_id,
        subject_id: this.$route.query.subject_id,
        // teaching_type: '',
        // curriculum_type: '',
        // page_no: 1,
        // page_size: 100,
      })
      if (res) {
        console.log('获取学校课程体系列表')
        console.log(res, 78945656)
        this.curriculum_list = res.curriculumList
        return res
      }
    },
    handleSizeChange10(val) {
      console.log(123)
      this.page_size10 = val
      getTeachingPlanStuList({
        teachingPlanId: this.teachingPlanId,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res, 89856)
        this.curriculumClassInfo1 = res.curriculumClassInfo
        res.stuPlanList.map((item) => {
          item.isShowInput = false
          if (item.cost_lesson_hour == null) {
            item.cost_lesson_hour = 0
          }
          item.cost_lesson_hour1 = 0
          item.cost_lesson_hour1 = item.cost_lesson_hour + item.over_lesson_hour
          item.ItemConstLessonHour = item.cost_lesson_hour
          item.ItemConstLessonHour1 = item.cost_lesson_hour1
        })
        this.stuPlanList1 = res.stuPlanList
        this.total10 = res.total
      })
    },
    handleCurrentChange10(val) {
      this.page_no10 = val
      console.log(123)
      getTeachingPlanStuList({
        teachingPlanId: this.teachingPlanId,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res)
        this.curriculumClassInfo1 = res.curriculumClassInfo
        res.stuPlanList.map((item) => {
          item.isShowInput = false
          if (item.cost_lesson_hour == null) {
            item.cost_lesson_hour = 0
          }
          item.cost_lesson_hour1 = 0
          item.cost_lesson_hour1 = item.cost_lesson_hour + item.over_lesson_hour
          item.ItemConstLessonHour = item.cost_lesson_hour
          item.ItemConstLessonHour1 = item.cost_lesson_hour1
        })
        this.stuPlanList1 = res.stuPlanList

        this.total10 = res.total
      })
    },
    num(row) {
      console.log(row, 789456)
      this.lessionTitle = row.lessionInfo.title
      this.ruleForm1.calssData = row.class_date
      this.ruleForm1.startTime = row.start_class_date.substr(
        row.start_class_date.length - 8
      )
      this.ruleForm1.endTime = row.end_class_date.substr(
        row.end_class_date.length - 8
      )
      if (this.is_cost_lesson_hour != false) {
        this.ruleForm1.cost_lesson_hour = row.cost_lesson_hour
      }
      this.dialogVisible9 = true
      this.teachingPlanId = row.id
      console.log(row.id, 4564)
      getTeachingPlanStuList({
        teachingPlanId: row.id,
        page_no: this.page_no10,
        page_size: this.page_size10,
      }).then((res) => {
        console.log(res, 456656123)
        this.curriculumClassInfo1 = res.curriculumClassInfo
        res.stuPlanList.map((item) => {
          item.isShowInput = false
          if (item.cost_lesson_hour == null) {
            item.cost_lesson_hour = 0
          }
          item.cost_lesson_hour1 = 0
          item.cost_lesson_hour1 = item.cost_lesson_hour + item.over_lesson_hour
          item.ItemConstLessonHour = item.cost_lesson_hour
          item.ItemConstLessonHour1 = item.cost_lesson_hour1
        })

        this.stuPlanList1 = res.stuPlanList
        console.log(this.stuPlanList1, 45412)

        this.total10 = res.total
      })
    },
    // 获取当前时间
    getTime() {
      var that = this
      let m = new Date().getMonth() + 1
      let yy = new Date().getFullYear()
      let mm = m < 10 ? '0' + m : m
      let dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      // let hh =
      //   new Date().getHours() < 10
      //     ? "0" + new Date().getHours()
      //     : new Date().getHours();
      // let mf =
      //   new Date().getMinutes() < 10
      //     ? "0" + new Date().getMinutes()
      //     : new Date().getMinutes();
      // let ss =
      //   new Date().getSeconds() < 10
      //     ? "0" + new Date().getSeconds()
      //     : new Date().getSeconds();

      that.gettime =
        yy + '-' + mm + '-' + dd + ' ' + '00' + ':' + '00' + ':' + '00'
      console.log(that.gettime, 5555)
      //赋值你的变量
      // that.loginForm.createTime = that.gettime
    },
    info() {
      console.log(JSON.parse(sessionStorage.getItem('courseArranging')), 784545)
      let that = this

      if (that.$route.query.paike === 'second') {
        that.activeName = 'second'
        JSON.parse(sessionStorage.getItem('courseArranging'))

        that.searchForm = JSON.parse(sessionStorage.getItem('courseArranging'))
        that.updateform.name = JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).name
        that.updateform.lecturer_id = JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).lecturer_id
        that.updateform.assistant_teacher_id = JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).assistant_teacher_id
      } else {
        // that.activeName = "first";
        if (this.$route.query.curriculum_class_type != 3) {
          that.activeName = 'first'
        } else {
          that.activeName = 'second'
        }
        JSON.parse(sessionStorage.getItem('courseArranging'))
        that.searchForm = JSON.parse(sessionStorage.getItem('courseArranging'))
        that.updateform.name = JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).name
        that.updateform.lecturer_id = JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).lecturer_id
        that.updateform.assistant_teacher_id = JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).assistant_teacher_id
      }
    },
    //删除
    del(row) {
      console.log(row)
      if (row.sign_state_new === 4) {
        this.$confirm(
          '该讲次已有上课记录，删除讲次会将学生的课堂作品一起删除，是否确定删除该讲次？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            delTchPlan({
              delTchPlanIds: JSON.stringify([row.id]),
            }).then((res) => {
              this.$message.success('删除成功')
              console.log(res)
              this.getPlan()
              this.getPlan1()
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      } else {
        this.$confirm('是否确定删除该讲次？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            delTchPlan({
              delTchPlanIds: JSON.stringify([row.id]),
            }).then((res) => {
              this.$message.success('删除成功')
              console.log(res)
              this.getPlan()
              this.getPlan1()
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      }
    },
    //撤销点名记录
    clear1() {
      console.log(123)
      this.$confirm('确定要清空本节课的上课记录和出勤记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.methodGrant(null, 'clear')
        clearTchPlan({
          teaching_plan_id: this.teachingPlanId,
        }).then((res) => {
          this.$message.success('清空记录成功')
          console.log(res)
          this.getPlan()
          this.getPlan1()
          this.dialogVisible9 = false
        })
      })
    },
    //清空
    clear(row) {
      console.log(123)

      this.$confirm('确定要清空本节课的上课记录和出勤记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        clearTchPlan({
          teaching_plan_id: row.id,
        }).then((res) => {
          this.$message.success('清空记录成功')
          console.log(res)
          this.getPlan()
          this.getPlan1()
        })
      })
    },

    handleClick(val) {
      console.log(event)
      console.log(val.label, 4567)
      if (val.label === '分班管理') {
        this.getClassStudentList()
      } else if (val.label === '排课管理') {
        this.getPlan()
        this.getPlan1()
      }
    },
    absenceFromDuty(row) {
      console.log(row.missStuTchPlanArr)
      this.absenceFromDutyList = row.missStuTchPlanArr
      this.dialogVisible5 = true
    },

    goBack() {
      this.$router.push({
        name: 'class-management1',
      })
    },
    searchName() {
      this.page_no = 1
      this.getClassStudentList()
    },
    handleSizeChange11(val) {
      this.page_size11 = val
      this.getTeachingPlanStuList(this.teachingPlanId)
    },
    handleCurrentChange11(val) {
      this.page_no11 = val
      this.getTeachingPlanStuList(this.teachingPlanId)
    },
    //点名
    changeTime(val) {
      console.log(val, 87884545)
    },
    async methodGrant(stuRow, flag) {
      if (this.showGrant) {
        const attendIds = [],
          absenceIds = []
        if (stuRow) {
          if (Number(stuRow.sign_state) === 1) {
            attendIds[0] = stuRow.stuId
          } else if (Number(stuRow.sign_state) === 2) {
            absenceIds[0] = stuRow.stuId
          }
        } else {
          const stuList =
            flag === 'clear' ? this.stuPlanList1 : this.SignStudents
          stuList.forEach((item) => {
            if (flag && flag === 'clear') {
              // 撤销点名
              absenceIds.push(item.student_user_id)
            } else {
              if (Number(item.sign_state) === 1) {
                attendIds.push(item.student_user_id)
              }
              if (Number(item.sign_state) === 2) {
                absenceIds.push(item.student_user_id)
              }
            }
          })
        }
        await api_schoolStarGrantSignGrant({
          attendStuIdList: attendIds, // 出勤学生IdList
          absenceStuIdList: absenceIds, // 缺勤学生IdList
          eduCampusId: this.$store.state.user.selected_schools[0], // 校区Id
          tchPlanId: this.teachingPlanId, // 教学计划Id
        })
      }
    },
    GoSign(row) {
      this.startCalssdate = row.class_date
      console.log(this.start_class_date1, 7484645)
      this.lessionTitle = row.lessionInfo.title
      console.log(this.searchForm, 7899146)
      console.log(row, 7899146)
      this.calssDate = row.class_date
      // this.startCalssdate = row.start_class_date
      if (row.class_date === null) {
        this.ruleForm1.calssData = moment().format('YYYY-MM-DD')
      } else {
        this.ruleForm1.calssData = row.class_date
        if (row.start_class_date) {
          this.ruleForm1.startTime = row.start_class_date.substr(
            row.start_class_date.length - 8
          )
        }
        if (row.end_class_date) {
          this.ruleForm1.endTime = row.end_class_date.substr(
            row.end_class_date.length - 8
          )
        }
      }

      this.teachingPlanId = row.id
      if (row.start_class_date === null && row.end_class_date == null) {
        this.isShow = false
      } else {
        this.isShow = true
      }

      if (row.start_class_date === null && row.end_class_date === null) {
        // row.start_class_date = "";
        // row.end_class_date = "";
        console.log(row.start_class_date)
        console.log(row.end_class_date)
        this.SignStudents = []
        this.dialogFormVisible9 = true
        this.SignClassInfo = row
        this.current_teachplan_id = row.id
        console.log(row)
        this.getTeachingPlanStuList(row.id)
      } else {
        this.SignStudents = []
        this.dialogFormVisible9 = true
        this.SignClassInfo = row
        this.current_teachplan_id = row.id
        console.log(row)
        this.getTeachingPlanStuList(row.id)
      }
    },

    GoSignFalse(row) {
      this.teachingPlanId = row.id

      if (row.start_class_date === null && row.end_class_date == null) {
        this.isShow = false
      } else {
        this.isShow = true
        this.ruleForm1.classTime = []
        this.ruleForm1.classTime.push(row.start_class_date, row.end_class_date)
      }

      if (row.start_class_date === null && row.end_class_date === null) {
        // row.start_class_date = "";
        // row.end_class_date = "";
        console.log(row.start_class_date)
        console.log(row.end_class_date)
        this.SignStudents = []
        this.dialogFormVisible9 = true
        this.SignClassInfo = row
        this.current_teachplan_id = row.id
        console.log(row)
        this.getTeachingPlanStuList(row.id)
      } else {
        this.SignStudents = []
        this.dialogFormVisible9 = true
        this.SignClassInfo = row
        this.current_teachplan_id = row.id
        console.log(row)
        this.getTeachingPlanStuList(row.id)
      }
    },

    //获得教学计划对应的学生计划列表
    getTeachingPlanStuList(id) {
      getTeachingPlanStuList({
        teachingPlanId: id,
        page_no: 1,
        page_size: 500,
      }).then((res) => {
        console.log('获得教学计划对应的学生计划列表')
        console.log(res)
        this.curriculumClassInfo = res.curriculumClassInfo
        console.log(this.curriculumClassInfo, 45412)
        console.log(res, 45412)
        // 不计课时班级点名签到是否计费
        const noXmClassSign = this.$store.state.user.schoolInfo.noXmClassSign;
        if (this.curriculumClassInfo.is_cost_lesson_hour != false) {
          this.ruleForm1.cost_lesson_hour = this.curriculumClassInfo.lesson_hour

          res.stuPlanList.map((item) => {
            if (item.stu_tch_plan_type != 4 && item.stu_tch_plan_type != 5) {
              item.lesson_hour = 0
              item.stuClassRelation = {}
              item.stuClassRelation.lesson_hour = this.curriculumClassInfo.lesson_hour
              item.ItemStuClassRelationLessonHour = item.stuClassRelation.lesson_hour
            }
            item.sign_state = 1
            if (item.stu_tch_plan_type == 5 && item.sign_state == 1) {
              item.cost_lesson_hour = this.ruleForm1.cost_lesson_hour
            }
          })
        } else {
          res.stuPlanList.map((item) => {
            if (item.cost_state == null) {
              item.cost_state = '1'
            }
          })
        }
        res.stuPlanList.map((item) => {
          item.sign_state = 1
          if (item.stu_tch_plan_type == 5) {
            item.cost_lesson_hour = this.$route.query.lesson_hour
            item.ItemConstLessonHour = item.cost_lesson_hour
          }
          item.cost_state = noXmClassSign ? 1 : 2;
        })
        // cost_state
        this.SignStudents = res.stuPlanList

        this.total11 = res.total
      })
    },
    //全部标记为计费
    SetAllCost(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('全部标记为计费')
      console.log(e)
      console.log(this.allcost)
      console.log(this.stuSignInfoList)

      if (!this.allcost) {
        console.log('批量计费')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].cost_state = 1
              }
            }
          }
        }
      } else {
        console.log('批量取消计费')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].cost_state = null
              }
            }
          }
        }
      }
    },
    //全部标记为出勤
    SetAllSign(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('全部标记为出勤')
      console.log(this.allsign)
      console.log(this.stuSignInfoList)

      if (!this.allsign) {
        console.log('批量全勤')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].sign_state = 1
              }
            }
          }
        }
      } else {
        console.log('批量取消全勤')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].sign_state = null
              }
            }
          }
        }
      }
    },
    //更新学员签到信息
    handleSelectionChange1(val) {
      console.log('签到学员列表')
      console.log(val)
      this.signStus = val
    },

    //从教学计划中移除学员
    deleteStuOfTeachingPlan(id) {
      this.$confirm('确定将该学员移出本讲次吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteStuOfTeachingPlan({
            teaching_plan_id: this.current_teachplan_id,
            studentId: id,
          }).then((res) => {
            console.log('将学员移除讲次')
            console.log(res)
            if (res.is_delete) {
              this.$message.success('移除学员成功')
              this.getTeachingPlanStuList(this.current_teachplan_id)
            }
          })
        })
        .catch(() => {
          console.log('取消移除')
        })
    },

    //生成补课计划
    openSupplementTchPlan() {
      if (this.signStus.length == 0) {
        this.$message.warning('请勾选补课学员')
        return
      }
      this.dialogVisible2 = true
    },

    updateSign(formName) {
      const startDate = moment().format('YYYY-MM-DD')
      if (moment(startDate).diff(moment(this.ruleForm1.calssData)) < 0) {
        this.$message.warning('只能为今天及今天以前的课次点名')
        return false
      }
      console.log(12313)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.methodGrant()
          console.log('签到学员信息')
          console.log(this.signStus)
          console.log('上课状态')
          console.log(this.SignClassInfo)
          console.log(this.ruleForm1, 87874554)
          if (this.curriculumClassInfo.is_cost_lesson_hour === false) {
            this.ruleForm1.cost_lesson_hour = ''
            this.updateTchPlanSignState(
              this.current_teachplan_id,
              this.ruleForm1.calssData,
              this.ruleForm1.startTime,
              this.ruleForm1.endTime,
              this.ruleForm1.cost_lesson_hour
            )
            this.stuSignInfoList = []
            for (let k = 0; k < this.SignStudents.length; k++) {
              const sign_stu = {
                stuTchPlanId: this.SignStudents[k].id,
                cost_state: this.SignStudents[k].cost_state,
                sign_state: this.SignStudents[k].sign_state,
                not_come_reason: this.SignStudents[k].not_come_reason,
                remark: this.SignStudents[k].remark,
              }
              this.stuSignInfoList.push(sign_stu)
            }
            console.log('转化后的学员信息')
            console.log(this.stuSignInfoList)
            this.updateStuTeachingPlanSignInfo()
          } else {
            console.log(1111, 12345)
            console.log(this.SignStudents, 12345)
            let SignStudentsNum = 0
            this.SignStudents.map((item) => {
              if (item.cost_xm_goods_id == null) {
                SignStudentsNum++
              }
            })
            if (SignStudentsNum > 0) {
              this.$message.warning('消耗方式不能为空')
              return false
            }
            console.log(12312, 12345)
            this.updateTchPlanSignState(
              this.current_teachplan_id,
              this.ruleForm1.calssData,
              this.ruleForm1.startTime,
              this.ruleForm1.endTime,
              this.ruleForm1.cost_lesson_hour
            )
            this.stuSignInfoList = []
            for (let k = 0; k < this.SignStudents.length; k++) {
              if (this.SignStudents[k].stu_tch_plan_type == 4) {
                const sign_stu = {
                  stuTchPlanId: this.SignStudents[k].id,
                  cost_state: '1',
                  sign_state: this.SignStudents[k].sign_state,
                  not_come_reason: this.SignStudents[k].not_come_reason,
                  remark: this.SignStudents[k].remark,
                  cost_xm_goods_id: this.SignStudents[k].cost_xm_goods_id,
                  total_cost_lesson_hour: this.SignStudents[k]
                    .xm_miss_cost_lesson_hour,
                }
                this.stuSignInfoList.push(sign_stu)
              } else if (this.SignStudents[k].stu_tch_plan_type == 5) {
                const sign_stu = {
                  stuTchPlanId: this.SignStudents[k].id,
                  cost_state: '1',
                  sign_state: this.SignStudents[k].sign_state,
                  not_come_reason: this.SignStudents[k].not_come_reason,
                  remark: this.SignStudents[k].remark,
                  cost_xm_goods_id: this.SignStudents[k].cost_xm_goods_id,
                  total_cost_lesson_hour: this.SignStudents[k].cost_lesson_hour,
                }
                this.stuSignInfoList.push(sign_stu)
              } else {
                const sign_stu = {
                  stuTchPlanId: this.SignStudents[k].id,
                  cost_state: '1',
                  sign_state: this.SignStudents[k].sign_state,
                  not_come_reason: this.SignStudents[k].not_come_reason,
                  remark: this.SignStudents[k].remark,
                  cost_xm_goods_id: this.SignStudents[k].cost_xm_goods_id,
                  total_cost_lesson_hour: this.SignStudents[k].stuClassRelation
                    .lesson_hour,
                }
                this.stuSignInfoList.push(sign_stu)
              }
            }
            console.log('转化后的学员信息')
            console.log(this.stuSignInfoList, 78956232)
            this.updateStuTeachingPlanSignInfo()
          }
        }
      })
    },
    //更新学员签到信息
    updateStuTeachingPlanSignInfo1() {
      updateStuTeachingPlanSignInfo({
        stuSignInfoList: JSON.stringify(this.stuSignInfoList),
        teaching_plan_id: this.current_teachplan_id,
        operate_state: '2',
      }).then((res) => {
        console.log('更新学员签到信息')
        console.log(res)
        if (res.is_update) {
          this.$message.success('签到成功')
          this.SignStudents = []
          getTeachingPlanStuList({
            teachingPlanId: this.current_teachplan_id,
            page_no: 1,
            page_size: 500,
          }).then((res) => {
            console.log(res, 'stuPlanList1')
            this.curriculumClassInfo1 = res.curriculumClassInfo
            res.stuPlanList.map((item) => {
              item.isShowInput = false
              if (item.cost_lesson_hour == null) {
                item.cost_lesson_hour = 0
              }
              item.cost_lesson_hour1 = 0
              item.cost_lesson_hour1 =
                item.cost_lesson_hour + item.over_lesson_hour
              item.ItemConstLessonHour = item.cost_lesson_hour
              item.ItemConstLessonHour1 = item.cost_lesson_hour1
            })
            this.stuPlanList1 = res.stuPlanList
            console.log(this.stuPlanList1, 45412)

            this.total10 = res.total
          })
          this.dialogFormVisible9 = false
          this.getPlan()
        }
      })
    },

    //更新学员签到信息
    updateStuTeachingPlanSignInfo() {
      updateStuTeachingPlanSignInfo({
        stuSignInfoList: JSON.stringify(this.stuSignInfoList),
        teaching_plan_id: this.current_teachplan_id,
        operate_state: '1',
      }).then((res) => {
        console.log('更新学员签到信息')
        console.log(res)
        if (res.is_update) {
          this.$message.success('签到成功')
          this.SignStudents = []
          this.getTeachingPlanStuList(this.current_teachplan_id)
          this.dialogFormVisible9 = false
          this.getPlan()
        }
      })
    },
    //更新教学计划的签到状态
    updateTchPlanSignState(
      id,
      calssData,
      startTime,
      endTime,
      cost_lesson_hour
    ) {
      console.log('更新上课状态')
      updateTchPlanSignState({
        // sign_state: '1',
        teaching_plan_id: id,
        class_date: calssData,
        start_class_date: startTime,
        end_class_date: endTime,
        cost_lesson_hour: cost_lesson_hour,
      }).then((res) => {
        console.log('更新教学计划的签到状态')
        console.log(res)
      })
    },

    goNext() {
      if (this.tchPlanInfos.length == 0) {
        this.$message.warning('请选择需要排课的讲次')
        return
      }
      sessionStorage.setItem('tchPlanInfos', JSON.stringify(this.tchPlanInfos)),
        console.log(this.tchPlanInfos, 45)
      this.$router.push({
        name: 'allDivide-class',
        query: {
          curriculum_class_type: this.$route.query.curriculum_class_type,
          id: this.$route.query.id,
          campus_id: this.$route.query.campus_id,
          curriculum_id: this.$route.query.curriculum_id,
          subject_id: this.$route.query.subject_id,
          is_cost_lesson_hour: this.$route.query.is_cost_lesson_hour,
          lesson_hour: this.$route.query.lesson_hour,
          classXmGoodsArr: this.$route.query.classXmGoodsArr,
          lecturer_id: this.$route.query.lecturer_id,
        },
      })
    },
    onSubmit() {
      // console.log("查询");
      this.page_no5 = 1
      this.lessonList()
    },
    // //修改班级信息

    //补课·
    InsertStudent2(index) {
      console.log('插入学员')
      console.log(index)
      this.gridData7.push(this.gridData6[index])

      console.log(this.gridData7)
      this.NoClassStudents1 = this.gridData7
    },
    Deleteoutputs2(index) {
      this.gridData7.splice(index, 1)
    },
    addLessons() {
      this.gridData7 = []
      this.dialogFormVisible10 = true
      this.lessonList()
    },
    submitButton() {
      this.multipleSelection1.map((item) => {
        this.gridData4.push(item)
      })
      this.multipleSelection1 = []
      this.$nextTick(() => {
        this.$refs.multipleTable1.clearSelection()
        this.isShowmultipleSelection1 = false
        this.NoClassStudents1 = this.gridData4
      })
    },
    handleSelectionChange2(val) {
      this.multipleSelection1 = val
      console.log(val, 123456)
      this.isShowmultipleSelection1 = true
    },
    InsertStudent1(index) {
      console.log('插入学员')
      console.log(index)
      this.gridData4.push(this.gridData3[index])

      // this.gridData4 = this.unique(this.gridData4);
      console.log(this.gridData4)
      this.NoClassStudents1 = this.gridData4
    },
    Deleteoutputs1(index) {
      this.gridData4.splice(index, 1)
    },

    //添加讲次
    async addLectureTimes() {
      this.NoClassStudents1 = []
      this.studentDataArr1 = []
      this.gridData4 = []
      this.dialogFormVisible8 = true
      await this.getCampusCurriculumtListByPage()
      this.lessonList()
    },

    //更新讲次信息
    UpdatePlanInfo(row) {
      console.log('更新讲次信息11')
      console.log(row, 784545)
      this.updateform.cost_lesson_hour = row.cost_lesson_hour
      if (row.sign_state === 1) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }

      this.if_ignore_conflict = 1
      this.updateform.sort_num = row.sort_num

      this.dialogFormVisible7 = true

      this.updateform.title = row.lessionInfo.title
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.lecturer_id = row.lecturer_id
      this.updateform.class_date = row.class_date
      this.updateform.classId = row.curriculum_class_id

      this.updateform.teaching_plan_id = row.id
      console.log(row.start_class_date, 78445)
      if (row.start_class_date != null) {
        var time0 = row.start_class_date.split(' ')[1]
        this.updateform.start_time = time0
      } else {
        this.updateform.start_time = ''
      }
      if (row.end_class_date != null) {
        var time1 = row.end_class_date.split(' ')[1]
        this.updateform.end_time = time1
      } else {
        this.updateform.end_time = ''
      }
      this.getCampusTeacherList()
    },
    updateTeachingPlan() {
      console.log('更新讲次参数')
      console.log(this.updateform)
      // if (!this.updateform.start_time) {
      //   this.$message.warning("请选择开始时间");
      //   return;
      // }

      // if (!this.updateform.end_time) {
      //   this.$message.warning("请选择结束时间");
      //   return;
      // }

      updateTeachingPlan({
        lecturer_id: this.updateform.lecturer_id,
        teaching_plan_id: this.updateform.teaching_plan_id,
        class_date: this.updateform.class_date,
        start_class_date: this.updateform.start_time,
        end_class_date: this.updateform.end_time,
        cost_lesson_hour: this.updateform.cost_lesson_hour,
        title: this.updateform.title,
        classId: this.updateform.classId,
        if_ignore_conflict: this.if_ignore_conflict,
        sort_num: this.updateform.sort_num,
      }).then((res) => {
        console.log('更新课程讲次')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
        }
        this.dialogFormVisible7 = false
        this.getPlan()
        this.getPlan1()
      })
    },

    handleSelectionChange(val) {
      console.log('删除讲次')
      console.log(val)
      this.tchPlanInfos = val
      this.tchPlanIds = []
      for (let k = 0; k < val.length; k++) {
        this.tchPlanIds.push(val[k].id)
      }

      console.log('即将删除的讲次id组')
      console.log(this.tchPlanIds)
    },
    //删除讲次
    deleteNormalClassTchPlan() {
      this.$confirm('确定删除已选中的讲次吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log('删除排课')
          if (this.tchPlanIds.length == 0) {
            this.$message.warning('请选择需要删除的讲次')
            return
          }
          delTchPlan({
            delTchPlanIds: JSON.stringify(this.tchPlanIds),
          }).then((res) => {
            console.log('删除排课')
            console.log(res)
            this.getPlan()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    AddStudentToPlan(row) {
      console.log('添加学员')
      console.log(row, 789456)
      this.current_teachplan_id = row.id
      this.dialogVisible1 = true
      this.teachplan_form.educational_institution_campus_id =
        row.educational_institution_campus_id
      //TODO 查询所有学员

      // v-if="is_cost_lesson_hour != false
      if (this.is_cost_lesson_hour != false) {
        this.getStuListForAddStuToTchPlan()
      } else {
        this.getFormalStudentListForAddToTchPlan()
      }
    },
    //添加学员
    CurrentChange_Student(val) {
      console.log('选择了学员')
      console.log(val, 7894456)
      this.stuList = val
    },
    getStuListForAddStuToTchPlan() {
      getStuListForAddStuToTchPlan({
        realName: this.form1.realname,
        teaching_plan_id: this.current_teachplan_id,
        page_no: this.page_no9,
        page_size: this.page_size9,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        res.studentList.map((item) => {
          item.xm_goods_id = null
          item.xmGoodsList.map((item1) => {
            if (item1.id === this.$route.query.gooid) {
              item.xm_goods_id = this.$route.query.gooid
            } else {
              item.xm_goods_id = item.xmGoodsList[0].id
            }
          })
        })

        this.Student_tableData = res.studentList
        this.total9 = res.total
      })
    },
    //查询所有正式学员
    getFormalStudentListForAddToTchPlan() {
      console.log('添加学员，所属校区')
      console.log(this.teachplan_form.educational_institution_campus_id)

      getFormalStudentListForAddToTchPlan({
        realname: this.form1.realname,
        leader: this.form1.leader,
        teaching_plan_id: this.current_teachplan_id,
        phone_a_num: this.form1.phone_a_num,
        normal_state: this.form1.normal_state,
        educational_institution_campus_id: this.teachplan_form
          .educational_institution_campus_id,
        page_no: this.page_no9,
        page_size: this.page_size9,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        this.Student_tableData = res.studentList
        this.total9 = res.total
      })
    },

    //向教学计划中添加学员
    addStuToTeachingPlan() {
      console.log('添加学员参数')
      console.log(this.current_teachplan_id)
      console.log(this.chooseStudent_current, 789456)

      addStuToTeachingPlan({
        teaching_plan_id: this.current_teachplan_id,
        studentIds: JSON.stringify(this.chooseStudent_current),
        stu_tch_plan_type: '5', //临调学员
      }).then((res) => {
        console.log('向教学计划中添加学员')
        console.log(res)
        if (res.is_update) {
          this.$message.success('添加学员成功')
          this.dialogVisible1 = false
          this.getPlan()
          this.getPlan1()
        }
      })
    },
    search_student() {
      // this.getFormalStudentListForAddToTchPlan();
      this.page_no9 = 1
      if (this.is_cost_lesson_hour != false) {
        this.getStuListForAddStuToTchPlan()
      } else {
        this.getFormalStudentListForAddToTchPlan()
      }
    },

    //分班新增/全部学员/收据
    checkTable(val) {
      console.log(val, 565656589)
      if (val === '0') {
        this.isTableList1 = true
        this.isTableList = false
      }
      if (val === '1') {
        this.isTableList = true
        this.isTableList1 = false
      }
      // if (val === true) {
      //   this.isTableList = true;
      //   this.getNotDivideStudentList();
      // }
    },
    //补课列表

    //排课列表

    getPlan1() {
      getPlan({
        is_supplement_tch_plan: 1,
        classes_id: JSON.parse(sessionStorage.getItem('courseArranging')).id,
      }).then((res) => {
        this.tableData5 = res.teaching_plan_list

        let sign_num = 0 //出勤

        this.tableData5.forEach((item) => {
          // console.log(item, 6666)
          for (let i = 0; i < item.stuTchPlanArr.length; i++) {
            if (item.stuTchPlanArr[i].sign_state === 1) {
              // console.log(item.stuTchPlanArr[i].sign_state, 12222222)
              sign_num++
            }
          }
          item.total_num = item.stuTchPlanArr.length
          item.sign_num = sign_num
          // console.log(sign_num, 5555)
          sign_num = 0
        })
      })
    },

    getPlan() {
      getPlan({
        classes_id: JSON.parse(sessionStorage.getItem('courseArranging')).id,
      }).then((res) => {
        this.tableData1 = res.teaching_plan_list

        let sign_num = 0 //出勤

        this.tableData1.forEach((item) => {
          // console.log(item, 6666)
          for (let i = 0; i < item.stuTchPlanArr.length; i++) {
            if (item.stuTchPlanArr[i].sign_state === 1) {
              // console.log(item.stuTchPlanArr[i].sign_state, 12222222)
              sign_num++
            }
          }
          item.total_num = item.stuTchPlanArr.length
          item.sign_num = sign_num
          // console.log(sign_num, 5555)
          sign_num = 0
        })
        let testTabel = localStorage.getItem('testTabelwidth')
        if (testTabel) {
          this.widthTable = testTabel
        }
        console.log(this.tableData1, 4444)
      })
    },
    //教师列表
    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      window.console.error('调用了' + Date.now())
      api_eduCampusSelectTchListByCampus({
        // campusId: this.updateform.educational_institution_campus_id
        //   ? this.updateform.educational_institution_campus_id
        //   : this.$store.state.user.selected_schools[0],
        eduCampusIdList: [this.updateform.educational_institution_campus_id],
        subjectId: this.updateform.subject_id,
        curriculumId: this.updateform.curriculum_id,
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        this.teacherList = res //主讲老师
        this.teacherListTo = res //助教老师
      })
    },

    getClassStudentList() {
      getClassStudentList({
        classId: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        realname: this.name,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询班级学员列表')
        console.log(res)
        this.tableData = res.studentList
        this.total = res.total
      })
    },

    search4() {
      this.getNotDivideStudentList()
    },

    //已报名未分班学员
    getNotDivideStudentList() {
      getNotDivideStudentList({
        classId: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        realname: '',
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('查询已报名未分班学员')
        console.log(res)
        this.tableData2 = res.studentList

        this.total2 = res.total
      })
    },

    Deleteoutputs(index) {
      this.gridData2.splice(index, 1)
    },

    //查看收据
    LookReceipt(row) {
      if (!row) {
        this.$message.warning('请关联收据，再查看.')
        return
      }

      console.log('查看收费收据')

      this.getReceiptChargeGoodsList(row)
    },

    //查询收据商品
    getReceiptChargeGoodsList(row) {
      this.DialogVisible = true
      console.log('查询收据详情')
      console.log(row)
      this.getCampusUserList()
      this.Current_Receipt = row
      this.goods_and_course_price = 0
      this.updateform.id = row.id
      this.updateform.bill_code = row.bill_code
      this.updateform.leader = row.leader
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.remark = row.remark
      this.updateform.charge_type = row.charge_type

      this.ReceiptData = []
      getReceiptChargeGoodsList({
        receipt_id: row.id,
      }).then((res) => {
        console.log('查询收据对应的商品')
        console.log(res)
        this.ReceiptData = res.receiptChargeGoodsList

        for (let k = 0; k < res.receiptChargeGoodsList.length; k++) {
          console.log(res.receiptChargeGoodsList[k].total_amount)
          this.goods_and_course_price =
            this.goods_and_course_price +
            res.receiptChargeGoodsList[k].total_amount
        }
      })
      //查询收据对应的账号
      getReceiptAccountList({
        receipt_id: row.id,
      }).then((res) => {
        console.log('查询收据对应的账户')
        console.log(res)
        this.receiptAccountList = res.receiptAccountList
      })
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    handleSelectionNoClassStudent(selection) {
      this.NoClassStudents = selection

      console.log('已选未分班学员')
    },
    //添加学员进班
    addStudentClassRelation1() {
      console.log(this.NoClassStudents1, 4444)
      if (this.NoClassStudents1.length == 0) {
        this.$message.warning('请选择讲次')
        return
      }

      this.studentDataArr1 = [] //清空学生ID组
      var studentData1 = {
        lessonId: '',
        curriculumId: '',
      }
      this.NoClassStudents1.map((item) => {
        studentData1 = {
          lessonId: item.id,
          curriculumId: item.curriculum_id,
        }
        this.studentDataArr1.push(studentData1)
      })
      console.log('添加学员参数')
      console.log(this.studentDataArr1)

      toClass({
        lessionDataArr: JSON.stringify(this.studentDataArr1),
        classId: JSON.parse(sessionStorage.getItem('courseArranging')).id,
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功')
        this.studentDataArr1 = []
        this.dialogFormVisible8 = false
        this.getPlan()
      })
    },

    //添加补课

    addStudentClassRelation2() {
      console.log(this.NoClassStudents1, 4444)
      if (this.NoClassStudents1.length == 0) {
        this.$message.warning('请选择讲次')
        return
      }

      this.studentDataArr1 = [] //清空学生ID组
      var studentData1 = {
        lessonId: '',
        curriculumId: '',
      }
      this.NoClassStudents1.map((item) => {
        studentData1 = {
          lessonId: item.id,
          curriculumId: item.curriculum_id,
        }
        this.studentDataArr1.push(studentData1)
      })
      console.log('添加学员参数')
      console.log(this.studentDataArr1)

      toClass({
        lessionDataArr: JSON.stringify(this.studentDataArr1),
        classId: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        is_supplement_tch_plan: 1,
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功')
        this.dialogFormVisible10 = false
        this.studentDataArr1 = []
        this.getPlan1()
      })
    },

    //添加学员进班
    addStudentClassRelation() {
      // console.log(is_cost_lesson_hour == false);

      console.log(this.NoClassStudents, 454545)

      if (this.NoClassStudents.length == 0) {
        this.$message.warning('请选择入班学员')
        return
      }

      this.studentDataArr = [] //清空学生ID组
      var studentData = {
        student_user_id: '',
        receiptGoodsId: '',
      }

      for (let k = 0; k < this.NoClassStudents.length; k++) {
        if (this.NoClassStudents[k].ClassGoodsInfo) {
          studentData = {
            student_user_id: this.NoClassStudents[k].ClassGoodsInfo
              .student_user_id,
            receiptGoodsId: this.NoClassStudents[k].ClassGoodsInfo.id,
          }
        } else {
          this.$message.warning('有学员未关联收据，请核对')
          return
        }

        this.studentDataArr.push(studentData)
      }

      console.log('添加学员参数')
      console.log(this.studentDataArr)

      addStudentClassRelation({
        studentDataArr: JSON.stringify(this.studentDataArr),
        curriculum_class_id: JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).id,
      }).then((res) => {
        console.log('添加学员进班')
        console.log(res)
        if (res.is_create) {
          if (res.failarr.length == 0) {
            this.$message.success('入班成功')
          } else {
            for (let k = 0; k < res.failarr.length; k++) {
              this.$notify({
                title: '提示',
                message: res.failarr[k].failReason,
                type: 'success',
                duration: 2000,
                offset: k * 100 + 100,
              })
            }
          }
          this.dialogTableVisible = false

          this.getClassStudentList()
          this.getNotDivideStudentList()
        }
      })
    },

    //加入更多学员
    AddMoreStudent() {
      console.log('加入更多学员')
      this.gridData2 = []
      this.dialogTableVisible = true

      if (this.is_cost_lesson_hour == false) {
        this.getFormalStudentList()
        this.getNotDivideStudentList()
      } else {
        this.getStuListForAddStuToClass()
      }
    },

    getStuListForAddStuToClass() {
      getStuListForAddStuToClass({
        class_id: this.$route.query.id,
        realName: this.form3.realname,
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log(res, 78946546)
        res.studentList.map((item) => {
          item.xm_goods_id = null
          item.xmGoodsList.map((item1) => {
            if (item1.id === this.$route.query.gooid) {
              item.xm_goods_id = this.$route.query.gooid
            } else {
              item.xm_goods_id = item.xmGoodsList[0].id
            }
          })
        })
        this.gridData = res.studentList
        this.total3 = res.total
        for (let k = 0; k < this.gridData.length; k++) {
          this.gridData[k].classlist = []
          // this.gridData[k].classTitle = [];

          for (let j = 0; j < this.gridData[k].stuClassArr.length; j++) {
            this.gridData[k].classlist.push(
              this.gridData[k].stuClassArr[j].className
            )
          }
          this.gridData[k].class_str = this.gridData[k].classlist.join(' , ')
          // this.gridData[k].class_title =
          //   this.gridData[k].classTitle.join(" , ");
        }
      })
    },
    //查询讲次
    lessonList() {
      let curriculum_id = ''
      if (this.form4.id) {
        curriculum_id = [this.form4.id]
      } else {
        let ids = []
        this.curriculum_list.forEach((item) => {
          ids.push(item.id)
        })
        curriculum_id = ids
      }
      getLessonListForClassAddLesson({
        // campusId: JSON.parse(sessionStorage.getItem('courseArranging'))
        //   .educational_institution_campus_id,
        lesson_title: this.form4.name,
        curriculum_id: window.JSON.stringify(curriculum_id),
        // curriculum_title: this.form4.title,
        // subjectId: this.searchForm.subject_id,
        page_no: this.page_no5,
        page_size: this.page_size5,
      }).then((res) => {
        this.gridData3 = res.lessonList
        this.gridData6 = res.lessonList

        this.total5 = res.total
      })
    },
    //查询所有正式学员
    getFormalStudentList() {
      getNoXmStuForClassAddStu({
        realname: this.form3.realname,
        classId: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        // campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        campusIds: window.JSON.stringify([
          this.searchForm.educational_institution_campus_id,
        ]),
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        res.studentList.map((item) => {
          item.xm_goods_id = null
        })
        this.gridData = res.studentList
        this.total3 = res.total
        //班级列表转字符串
        for (let k = 0; k < this.gridData.length; k++) {
          this.gridData[k].classlist = []
          this.gridData[k].classTitle = []

          for (let j = 0; j < this.gridData[k].stuClassArr.length; j++) {
            this.gridData[k].classlist.push(
              this.gridData[k].stuClassArr[j].classInfo.name
            )
            this.gridData[k].classTitle.push(
              this.gridData[k].stuClassArr[j].classInfo.curriculumInfo.title
            )
          }
          this.gridData[k].class_str = this.gridData[k].classlist.join(' , ')
          this.gridData[k].class_title = this.gridData[k].classTitle.join(' , ')
        }
      })
    },

    InsertStudent(index, row) {
      console.log(this.is_cost_lesson_hour, 78465)
      console.log(row, 78465)
      console.log('插入学员')
      console.log(index)
      if (this.is_cost_lesson_hour === true) {
        console.log(row.xm_goods_id, 123456)
        if (row.xm_goods_id === undefined) {
          this.$message.warning('请选择消耗方式')
        } else {
          this.gridData2.push(this.gridData[index])
          this.gridData2 = this.unique(this.gridData2)
          console.log(this.gridData2)
        }
      } else {
        this.gridData2.push(this.gridData[index])
        this.gridData2 = this.unique(this.gridData2)
        console.log(this.gridData2)
      }
    },

    //数组对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    handleCurrentChange9(val) {
      this.page_no9 = val
      if (this.is_cost_lesson_hour != false) {
        this.getStuListForAddStuToTchPlan()
      } else {
        this.getFormalStudentListForAddToTchPlan()
      }
      // this.getNotDivideStudentList();
    },
    handleSizeChange9(val) {
      this.page_size9 = val
      this.getFormalStudentListForAddToTchPlan()
    },
    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getNotDivideStudentList()
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getClassStudentList()
    },

    handleSizeChange(val) {
      this.page_size = val
      this.getClassStudentList()
    },

    handleCurrentChange3(val) {
      this.page_no3 = val

      if (this.is_cost_lesson_hour == false) {
        console.log(123456, 789)
        this.getFormalStudentList()
      } else {
        console.log(78946456, 789)
        this.getStuListForAddStuToClass()
      }
      // this.getFormalStudentList();
    },

    handleSizeChange3(val) {
      this.page_size3 = val
      // this.getFormalStudentList();
      if (this.is_cost_lesson_hour == false) {
        console.log(123456, 789)
        this.getFormalStudentList()
      } else {
        console.log(78946456, 789)
        this.getStuListForAddStuToClass()
      }
    },

    handleCurrentChange5(val) {
      this.page_no5 = val
      this.lessonList()
    },

    handleSizeChange5(val) {
      this.page_size5 = val
      this.lessonList()
    },

    search3() {
      this.page_no3 = 1
      // this.getFormalStudentList();
      if (this.is_cost_lesson_hour == false) {
        console.log(123456, 789)
        this.getFormalStudentList()
      } else {
        console.log(78946456, 789)
        this.getStuListForAddStuToClass()
      }
    },
    handleSelectionChangegridData(val) {
      this.multipleSelection = val
    },
    //从全部学员加入班级
    addStudentClassRelationFromAll() {
      if (this.is_cost_lesson_hour == true) {
        console.log(123456)
        this.studentDataArr = [] //清空学生ID组
        var studentData1 = {
          student_user_id: '',
        }
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请选择学员')
          return
        }
        for (let k = 0; k < this.multipleSelection.length; k++) {
          studentData1 = {
            student_user_id: this.multipleSelection[k].id,
            xm_goods_id: this.multipleSelection[k].xm_goods_id,
          }
          this.studentDataArr.push(studentData1)
          console.log(this.studentDataArr, 78456)
        }
        addStudentClassRelation({
          studentDataArr: JSON.stringify(this.studentDataArr),
          if_add_receipt_info: '0',
          curriculum_class_id: JSON.parse(
            sessionStorage.getItem('courseArranging')
          ).id,
        }).then((res) => {
          console.log('添加学员进班')
          console.log(res)
          if (res.is_create) {
            if (res.failarr.length == 0) {
              this.$message.success('入班成功')
              this.dialogTableVisible = false
            } else {
              let str = ''
              console.log(res.failarr, 789465)
              res.failarr.map((item, index) => {
                console.log(item, 7874)

                console.log(
                  this.multipleSelection[index].studentUserInfo.realname,
                  789465
                )
                str +=
                  this.multipleSelection[index].studentUserInfo.realname + ','
              })
              console.log(str, 789465)
              this.$notify({
                title: '提示',
                message: str + '学员已经在班级内，不能重复添加',
                type: 'success',
              })
            }
            this.dialogTableVisible = false
            this.getClassStudentList()
          }
        })
      } else {
        console.log('加入班级')
        console.log(this.gridData2)

        this.studentDataArr = [] //清空学生ID组
        var studentData = {
          student_user_id: '',
        }

        if (this.gridData2.length == 0) {
          this.$message.warning('请选择学员')
          return
        }
        console.log(this.gridData2, 78748456456)
        for (let k = 0; k < this.gridData2.length; k++) {
          studentData = {
            student_user_id: this.gridData2[k].id,
            xm_goods_id: this.gridData2[k].xm_goods_id,
          }
          this.studentDataArr.push(studentData)
        }
        addStudentClassRelation({
          studentDataArr: JSON.stringify(this.studentDataArr),
          if_add_receipt_info: '0',
          curriculum_class_id: JSON.parse(
            sessionStorage.getItem('courseArranging')
          ).id,
        }).then((res) => {
          console.log('添加学员进班')
          console.log(res)
          if (res.is_create) {
            if (res.failarr.length == 0) {
              this.$message.success('入班成功')
              this.dialogTableVisible = false
            } else {
              for (let k = 0; k < res.failarr.length; k++) {
                this.$notify({
                  title: '提示',
                  message:
                    this.gridData2[k].studentUserInfo.realname +
                    ',' +
                    res.failarr[k].failReason,
                  type: 'success',
                  duration: 2000,
                  offset: k * 100 + 100,
                })
              }
            }
            this.dialogTableVisible = false
            this.getClassStudentList()
          }
        })
      }
    },

    CancelAdd() {
      this.dialogTableVisible = false
      this.gridData2 = []
    },
    yichu(row) {
      this.$confirm('学员移出班级后,未上讲次会被删除,谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delStudentClassRelation({
            studentIds: JSON.stringify([row.studentInfo.id]),
            curriculum_class_id: JSON.parse(
              sessionStorage.getItem('courseArranging')
            ).id,
          }).then(() => {
            this.$message.success('移除成功')
            this.getClassStudentList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },

    //班级移除学员
    delStudentClassRelation() {
      if (this.OutClassStudents.length == 0) {
        this.$message.warning('请选择要移除的学员')
        return
      }

      console.log(this.OutClassStudents)

      this.$confirm('学员移出班级后,未上讲次会被删除,谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.outstudentIds = [] //清空学生ID组
        for (let k = 0; k < this.OutClassStudents.length; k++) {
          this.outstudentIds.push(this.OutClassStudents[k].studentInfo.id)
        }
        console.log('移除学员参数')
        console.log(this.outstudentIds)

        delStudentClassRelation({
          studentIds: JSON.stringify(this.outstudentIds),
          curriculum_class_id: JSON.parse(
            sessionStorage.getItem('courseArranging')
          ).id,
        }).then((res) => {
          console.log('班级移除学员')
          console.log(res)
          if (res.is_delete) {
            if (res.failArr.length == 0) {
              this.$message.success('移除成功')
            } else {
              for (let k = 0; k < res.failArr.length; k++) {
                this.$notify({
                  title: '警告:',
                  message:
                    this.OutClassStudents[k].studentInfo.studentUserInfo
                      .realname +
                    ',' +
                    res.failArr[k].msg,
                  type: 'warning',
                  duration: 4000,
                  offset: k * 100 + 100,
                })
              }
            }

            this.getClassStudentList()
            this.getNotDivideStudentList()
          }
        })
      })
    },

    //移除班级的学员
    handleSelectionOutClassStudent(selection) {
      this.OutClassStudents = selection
      console.log('已选即将移出班级的学员')
      console.log(this.OutClassStudents)
    },

    //可调入班级列表
    getClassListForStuChangeClass(row) {
      console.log('调班学员')
      // xm_goods_id

      console.log(row, 121654)
      this.current_student = row
      this.current_student_id = row.student_user_id

      getClassListForStuChangeClass({
        xm_goods_id: row.xm_goods_id,
        educational_institution_campus_id: JSON.parse(
          sessionStorage.getItem('courseArranging')
        ).educational_institution_campus_id,
        curriculum_id: JSON.parse(sessionStorage.getItem('courseArranging'))
          .curriculum_id,
        now_class_id: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        className: this.changeform.className,
        lecturer_id: '',
        page_no: this.page_no4,
        page_size: this.page_size4,
      }).then((res) => {
        console.log('查询可调入班级')
        console.log(res)
        this.outerVisible2 = true
        this.stuChange_ClassList = res.classList
        this.total4 = res.total
      })
    },

    handleCurrentChange4(val) {
      this.page_no4 = val
      this.getClassListForStuChangeClass(this.current_student)
    },

    search1() {
      this.page_no4 = 1
      this.getClassListForStuChangeClass(this.current_student)
    },

    //目标调入班级选择
    SelectTargetClass(val) {
      console.log('选择了目标调入班级')
      console.log(val)
      this.target_change_class = val
    },

    //调班接口
    changeStuClass() {
      console.log('调班操作')
      changeStuClass({
        student_user_id: this.current_student_id,
        now_class_id: JSON.parse(sessionStorage.getItem('courseArranging')).id,
        change_class_id: this.target_change_class.id,
      }).then((res) => {
        console.log('调班接口')
        console.log(res)
        if (res.is_change) {
          this.$message.success('调班成功')
          this.outerVisible2 = false
          this.getClassStudentList()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
  }
}

.searchmsg {
  background: #fff;
  margin: 10px;
  border-radius: 5px;
  box-sizing: border-box;
}

.btnright {
  float: right;
  margin-top: 33px;
}

.searchClass /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}

.changeTag {
  float: right;
  position: relative;
  z-index: 999;
}

.msg {
  color: rgba(24, 144, 255, 1);
  font-size: 14px;
  cursor: pointer;
}

.jctxt {
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
}

.fl {
  float: left;
}

.txt {
  display: inline-block;
  // width: 75px;
  text-align: left;
  font-size: 14px;
  padding: 0 5px 0 0;
  box-sizing: border-box;
  font-weight: bold;
}

.clear {
  overflow: hidden;
}

.courseArranging {
  .section {
    box-sizing: border-box;
    margin: 10px;
    padding: 5px 15px 15px 15px;
    border-radius: 5px;
    background-color: #fff;

    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
      font-size: 12px;
      padding-right: 5px;
      padding-left: 10px;
    }

    .arrang_btn {
      margin-bottom: 20px;
    }

    .classdate {
      margin-top: 20px;

      .classdate_start {
        font-weight: 500;
      }

      .classdate_stop {
        font-weight: 500;
      }
    }

    .hint {
      margin-left: 30px;
      font-size: 14px;
      color: red;
    }

    .time-frame {
      background-color: #f7f8fa;
      margin: 20px 0 0 20px;
      padding: 20px 0;
      border-radius: 5px;

      .frame {
        display: flex;
        align-items: center;
        border-radius: 5px;

        .title {
          font-size: 14px;
          margin-left: 20px;
        }

        .time {
          margin-left: 20px;
        }
      }
    }

    .btn {
      margin: 20px 0 0 20px;
    }

    .dialog {
      padding-bottom: 20px;
    }

    /deep/ .el-switch__label {
      color: #b9b7b7 !important;
    }

    /deep/ .el-switch__label.is-active {
      color: #409eff !important;
      font-weight: bold;
    }
  }
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .classHour .el-icon-arrow-up:before {
  content: "";
}

/deep/ .el-form-item__error {
  font-size: 12px;
  font-weight: 400;
  color: red;
}
</style>
